export const universityData = {
  "american_university": {
    "Name": "American University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "American Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "American"
      ]
    },
    "prompts": [
      {
        "category": [
          "What inspires you"
        ],
        "options": [
          "None"
        ],
        "prompt": "American University students identify as changemakers and describe themselves as passionate. Describe a belief, hobby, idea, issue, or topic about which you’re excited.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "amherst_college": {
    "Name": "Amherst College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "QuestBridge App",
        "Amherst Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Amherst"
      ]
    },
    "prompts": [
      {
        "category": [
          "Additional Info"
        ],
        "options": [],
        "prompt": "Optional additional identity information: Please tell us more about yourself that is not captured elsewhere in your application. (175 words)",
        "status": "Optional",
        "wordCount": "175 words"
      },
      {
        "category": [
          "Other"
        ],
        "options": [],
        "prompt": "Do you identify as a member of the LGBTQ+ community? If you wish to share more about your LGBTQ+ affiliation, please use the space below. (75 words)",
        "status": "Optional",
        "wordCount": "75 words"
      },
      {
        "category": [
          "Activity"
        ],
        "options": [],
        "prompt": "Please briefly elaborate on an extracurricular activity or work experience of particular significance to you. (175 words)",
        "status": "Optional",
        "wordCount": "175 words"
      },
      {
        "category": [
          "Other"
        ],
        "options": [],
        "prompt": "If you have engaged in significant research independently of your high school curriculum, please provide a brief description of the research project. (50-75 words)",
        "status": "Optional",
        "wordCount": "75 words"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "“We seek an Amherst made stronger because it includes those whose experiences can enhance our understanding of our nation and our world. We do so in the faith that our humanity is an identity forged from diversity, and that our different perspectives enrich our inquiry, deepen our knowledge, strengthen our community, and prepare students to engage with an ever-changing world.” – from the Trustee Statement on Diversity and Community. In what ways could your unique experiences enhance our understanding of our nation and our world?",
          "“Strong commitment to the freedom of inquiry lies at the heart of Amherst College’s mission to create a home in which the liberal arts may flourish. As a small residential liberal arts college that prides itself on the ability, curiosity, and diversity of its students, Amherst seeks to create a respectful environment in which members of its community feel emboldened to pursue their intellectual and creative passions.” – from the Amherst College Statement of Academic and Expressive Freedom. Tell us about an intellectual or creative passion you have pursued; what did you learn about yourself through that pursuit?",
          "Option B: Submit a graded paper from your junior or senior year that best represents your writing skills and analytical abilities.",
          "Option C: If you are/were an applicant to Amherst’s Access to Amherst (A2A) program, you may use your A2A application essay."
        ],
        "prompt": "“Amherst College is committed to learning through close colloquy and to expanding the realm of knowledge through scholarly research and artistic creation at the highest level. Its graduates link learning with leadership—in service to the College, to their communities, and to the world beyond.” – from the Mission of Amherst College. What do you see as the benefits of linking learning with leadership and/or service? In your response, please share with us a time where you have seen that benefit through your own experience.",
        "status": "Mandatory",
        "wordCount": "350 words"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "“Amherst College is committed to learning through close colloquy and to expanding the realm of knowledge through scholarly research and artistic creation at the highest level. Its graduates link learning with leadership—in service to the College, to their communities, and to the world beyond.” – from the Mission of Amherst College. What do you see as the benefits of linking learning with leadership and/or service?",
          "“Strong commitment to the freedom of inquiry lies at the heart of Amherst College’s mission to create a home in which the liberal arts may flourish. As a small residential liberal arts college that prides itself on the ability, curiosity, and diversity of its students, Amherst seeks to create a respectful environment in which members of its community feel emboldened to pursue their intellectual and creative passions.” – from the Amherst College Statement of Academic and Expressive Freedom. Tell us about an intellectual or creative passion you have pursued; what did you learn about yourself through that pursuit?",
          "Option B: Submit a graded paper from your junior or senior year that best represents your writing skills and analytical abilities.",
          "Option C: If you are/were an applicant to Amherst’s Access to Amherst (A2A) program, you may use your A2A application essay."
        ],
        "prompt": "“We seek an Amherst made stronger because it includes those whose experiences can enhance our understanding of our nation and our world. We do so in the faith that our humanity is an identity forged from diversity, and that our different perspectives enrich our inquiry, deepen our knowledge, strengthen our community, and prepare students to engage with an ever-changing world.” – from the Trustee Statement on Diversity and Community. In what ways could your unique experiences enhance our understanding of our nation and our world?",
        "status": "Mandatory",
        "wordCount": "350 words"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "“Amherst College is committed to learning through close colloquy and to expanding the realm of knowledge through scholarly research and artistic creation at the highest level. Its graduates link learning with leadership—in service to the College, to their communities, and to the world beyond.” – from the Mission of Amherst College. What do you see as the benefits of linking learning with leadership and/or service?",
          "“We seek an Amherst made stronger because it includes those whose experiences can enhance our understanding of our nation and our world. We do so in the faith that our humanity is an identity forged from diversity, and that our different perspectives enrich our inquiry, deepen our knowledge, strengthen our community, and prepare students to engage with an ever-changing world.” – from the Trustee Statement on Diversity and Community. In what ways could your unique experiences enhance our understanding of our nation and our world?",
          "Option B: Submit a graded paper from your junior or senior year that best represents your writing skills and analytical abilities.",
          "Option C: If you are/were an applicant to Amherst’s Access to Amherst (A2A) program, you may use your A2A application essay."
        ],
        "prompt": "“Strong commitment to the freedom of inquiry lies at the heart of Amherst College’s mission to create a home in which the liberal arts may flourish. As a small residential liberal arts college that prides itself on the ability, curiosity, and diversity of its students, Amherst seeks to create a respectful environment in which members of its community feel emboldened to pursue their intellectual and creative passions.” – from the Amherst College Statement of Academic and Expressive Freedom. Tell us about an intellectual or creative passion you have pursued; what did you learn about yourself through that pursuit?",
        "status": "Mandatory",
        "wordCount": "350 words"
      },
      {
        "category": [
          "Extended Essay"
        ],
        "options": [
          "“Amherst College is committed to learning through close colloquy and to expanding the realm of knowledge through scholarly research and artistic creation at the highest level. Its graduates link learning with leadership—in service to the College, to their communities, and to the world beyond.” – from the Mission of Amherst College. What do you see as the benefits of linking learning with leadership and/or service?",
          "“We seek an Amherst made stronger because it includes those whose experiences can enhance our understanding of our nation and our world. We do so in the faith that our humanity is an identity forged from diversity, and that our different perspectives enrich our inquiry, deepen our knowledge, strengthen our community, and prepare students to engage with an ever-changing world.” – from the Trustee Statement on Diversity and Community. In what ways could your unique experiences enhance our understanding of our nation and our world?",
          "“Strong commitment to the freedom of inquiry lies at the heart of Amherst College’s mission to create a home in which the liberal arts may flourish. As a small residential liberal arts college that prides itself on the ability, curiosity, and diversity of its students, Amherst seeks to create a respectful environment in which members of its community feel emboldened to pursue their intellectual and creative passions.” – from the Amherst College Statement of Academic and Expressive Freedom. Tell us about an intellectual or creative passion you have pursued; what did you learn about yourself through that pursuit?",
          "Option C: If you are/were an applicant to Amherst’s Access to Amherst (A2A) program, you may use your A2A application essay."
        ],
        "prompt": "Option B: Submit a graded paper from your junior or senior year that best represents your writing skills and analytical abilities.",
        "status": "Mandatory",
        "wordCount": "N/A"
      },
      {
        "category": [
          "Extended Essay"
        ],
        "options": [
          "“Amherst College is committed to learning through close colloquy and to expanding the realm of knowledge through scholarly research and artistic creation at the highest level. Its graduates link learning with leadership—in service to the College, to their communities, and to the world beyond.” – from the Mission of Amherst College. What do you see as the benefits of linking learning with leadership and/or service?",
          "“We seek an Amherst made stronger because it includes those whose experiences can enhance our understanding of our nation and our world. We do so in the faith that our humanity is an identity forged from diversity, and that our different perspectives enrich our inquiry, deepen our knowledge, strengthen our community, and prepare students to engage with an ever-changing world.” – from the Trustee Statement on Diversity and Community. In what ways could your unique experiences enhance our understanding of our nation and our world?",
          "“Strong commitment to the freedom of inquiry lies at the heart of Amherst College’s mission to create a home in which the liberal arts may flourish. As a small residential liberal arts college that prides itself on the ability, curiosity, and diversity of its students, Amherst seeks to create a respectful environment in which members of its community feel emboldened to pursue their intellectual and creative passions.” – from the Amherst College Statement of Academic and Expressive Freedom. Tell us about an intellectual or creative passion you have pursued; what did you learn about yourself through that pursuit?",
          "Option B: Submit a graded paper from your junior or senior year that best represents your writing skills and analytical abilities."
        ],
        "prompt": "Option C: If you are/were an applicant to Amherst’s Access to Amherst (A2A) program, you may use your A2A application essay in satisfaction of our Writing Supplement requirement.",
        "status": "Mandatory",
        "wordCount": "N/A"
      }
    ]
  },
  "babson_college": {
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Babson Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Babson"
      ]
    },
    "name": "Babson College",
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "The Babson education prepares students for all types of careers across business, entrepreneurship, social innovation, and more. Tell us about your interest in this area of study and in Babson specifically.",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Diversity",
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "A defining element of the Babson experience is learning and thriving in an equitable and inclusive community with a wide range of perspectives and interests. Please share something about your background, lived experiences, or viewpoint(s) that speaks to how you will contribute to and learn from Babson’s collaborative community.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "bard_college": {
    "Name": "Bard College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Bard Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Bard"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Why Bard?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "barnard_college": {
    "Name": "Barnard College",
    "applications": {
      "appType": [
        "Barnard Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Barnard"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "Barnard College is an extraordinary community of women committed to fostering curiosity and the exploration of new experiences and ideas. By utilizing the resources of our campus, our Foundations curriculum, and New York City, our students expand their world and discover their own capabilities. How do you envision these intersecting components of Barnard shaping your academic and personal journey?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Opinions",
        "options": "None",
        "prompt": "In college, you will encounter others with diverse viewpoints and experiences. Describe an instance where you engaged with someone who held a different opinion and explain how it shaped your perspective on the issue.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Barnard College students engage in the bold questions that define their generation. Choose one question that you have about the world around you, and explain why it matters to you.",
        "status": "Mandatory",
        "wordCount": "150"
      }
    ]
  },
  "baylor_university": {
    "Name": "Baylor University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Baylor Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Baylor"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "What are you looking for in a university, why do you want to attend Baylor, and how do you see yourself contributing to the Baylor community?",
        "status": "Mandatory",
        "wordCount": "450"
      }
    ]
  },
  "boston_college": {
    "Name": "Boston College",
    "applications": {
      "appType": [
        "Common App",
        "QuestBridge App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Boston College"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "At Boston College, we draw upon the Jesuit tradition of finding worthwhile conversation partners. Some support our viewpoints while others challenge them. Who fulfills this role in your life? Please cite a specific conversation you had where this conversation partner challenged your perspective or you challenged theirs.",
          "In her November 2019 Ted Talk, “The Danger of a Single Story,” Chimamanda Ngozi Adichie warned viewers against assigning people a “single story” through assumptions about their nationality, appearance, or background. Discuss a time when someone defined you by a single story. What challenges did this present and how did you overcome them?",
          "Boston College’s founding in 1863 was in response to society’s call. That call came from an immigrant community in Boston seeking a Jesuit education to foster social mobility. Still today, the University empowers its students to use their education to address society’s greatest needs. Which of today’s local or global issues is of particular concern to you and how might you use your Boston College education to address it?",
          "Human-Centered Engineering (HCE) Applicants only: One goal of a Jesuit education is to prepare students to serve the Common Good. Human-Centered Engineering at Boston College integrates technical knowledge, creativity, and a humanistic perspective to address societal challenges and opportunities. What societal problems are important to you and how will you use your HCE education to solve them?"
        ],
        "prompt": "Each year at University Convocation, our incoming class engages in reflective dialogue with the author of a common text. What book by a living author would you recommend for your incoming class to read, and why would this be an important shared text?",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": [
          "Opinions"
        ],
        "options": [
          "Each year at University Convocation, our incoming class engages in reflective dialogue with the author of a common text. What book by a living author would you recommend for your incoming class to read, and why would this be an important shared text?",
          "In her November 2019 Ted Talk, “The Danger of a Single Story,” Chimamanda Ngozi Adichie warned viewers against assigning people a “single story” through assumptions about their nationality, appearance, or background. Discuss a time when someone defined you by a single story. What challenges did this present and how did you overcome them?",
          "Boston College’s founding in 1863 was in response to society’s call. That call came from an immigrant community in Boston seeking a Jesuit education to foster social mobility. Still today, the University empowers its students to use their education to address society’s greatest needs. Which of today’s local or global issues is of particular concern to you and how might you use your Boston College education to address it?",
          "Human-Centered Engineering (HCE) Applicants only: One goal of a Jesuit education is to prepare students to serve the Common Good. Human-Centered Engineering at Boston College integrates technical knowledge, creativity, and a humanistic perspective to address societal challenges and opportunities. What societal problems are important to you and how will you use your HCE education to solve them?"
        ],
        "prompt": "At Boston College, we draw upon the Jesuit tradition of finding worthwhile conversation partners. Some support our viewpoints while others challenge them. Who fulfills this role in your life? Please cite a specific conversation you had where this conversation partner challenged your perspective or you challenged theirs.",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": [
          "Diversity",
          "Experience"
        ],
        "options": [
          "Each year at University Convocation, our incoming class engages in reflective dialogue with the author of a common text. What book by a living author would you recommend for your incoming class to read, and why would this be an important shared text?",
          "At Boston College, we draw upon the Jesuit tradition of finding worthwhile conversation partners. Some support our viewpoints while others challenge them. Who fulfills this role in your life? Please cite a specific conversation you had where this conversation partner challenged your perspective or you challenged theirs.",
          "Boston College’s founding in 1863 was in response to society’s call. That call came from an immigrant community in Boston seeking a Jesuit education to foster social mobility. Still today, the University empowers its students to use their education to address society’s greatest needs. Which of today’s local or global issues is of particular concern to you and how might you use your Boston College education to address it?",
          "Human-Centered Engineering (HCE) Applicants only: One goal of a Jesuit education is to prepare students to serve the Common Good. Human-Centered Engineering at Boston College integrates technical knowledge, creativity, and a humanistic perspective to address societal challenges and opportunities. What societal problems are important to you and how will you use your HCE education to solve them?"
        ],
        "prompt": "In her November 2019 Ted Talk, “The Danger of a Single Story,” Chimamanda Ngozi Adichie warned viewers against assigning people a “single story” through assumptions about their nationality, appearance, or background. Discuss a time when someone defined you by a single story. What challenges did this present and how did you overcome them?",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": [
          "Why this college",
          "Other"
        ],
        "options": [
          "Each year at University Convocation, our incoming class engages in reflective dialogue with the author of a common text. What book by a living author would you recommend for your incoming class to read, and why would this be an important shared text?",
          "At Boston College, we draw upon the Jesuit tradition of finding worthwhile conversation partners. Some support our viewpoints while others challenge them. Who fulfills this role in your life? Please cite a specific conversation you had where this conversation partner challenged your perspective or you challenged theirs.",
          "In her November 2019 Ted Talk, “The Danger of a Single Story,” Chimamanda Ngozi Adichie warned viewers against assigning people a “single story” through assumptions about their nationality, appearance, or background. Discuss a time when someone defined you by a single story. What challenges did this present and how did you overcome them?",
          "Human-Centered Engineering (HCE) Applicants only: One goal of a Jesuit education is to prepare students to serve the Common Good. Human-Centered Engineering at Boston College integrates technical knowledge, creativity, and a humanistic perspective to address societal challenges and opportunities. What societal problems are important to you and how will you use your HCE education to solve them?"
        ],
        "prompt": "Boston College’s founding in 1863 was in response to society’s call. That call came from an immigrant community in Boston seeking a Jesuit education to foster social mobility. Still today, the University empowers its students to use their education to address society’s greatest needs. Which of today’s local or global issues is of particular concern to you and how might you use your Boston College education to address it?",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Each year at University Convocation, our incoming class engages in reflective dialogue with the author of a common text. What book by a living author would you recommend for your incoming class to read, and why would this be an important shared text?",
          "At Boston College, we draw upon the Jesuit tradition of finding worthwhile conversation partners. Some support our viewpoints while others challenge them. Who fulfills this role in your life? Please cite a specific conversation you had where this conversation partner challenged your perspective or you challenged theirs.",
          "In her November 2019 Ted Talk, “The Danger of a Single Story,” Chimamanda Ngozi Adichie warned viewers against assigning people a “single story” through assumptions about their nationality, appearance, or background. Discuss a time when someone defined you by a single story. What challenges did this present and how did you overcome them?",
          "Boston College’s founding in 1863 was in response to society’s call. That call came from an immigrant community in Boston seeking a Jesuit education to foster social mobility. Still today, the University empowers its students to use their education to address society’s greatest needs. Which of today’s local or global issues is of particular concern to you and how might you use your Boston College education to address it?"
        ],
        "prompt": "Human-Centered Engineering at Boston College integrates technical knowledge, creativity, and a humanistic perspective to address societal challenges and opportunities. What societal problems are important to you and how will you use your HCE education to solve them?",
        "status": "Mandatory",
        "wordCount": "400"
      }
    ]
  },
  "boston_university": {
    "Name": "Boston University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "QuestBridge App",
        "BU Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Boston University"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community"
        ],
        "options": [
          "Boston University is dedicated to our founding principles: 'that higher education should be accessible to all and that research, scholarship, artistic creation, and professional practice should be conducted in the service of the wider community—local and international.' These principles endure in the University’s insistence on the value of diversity in its tradition and standards of excellence and its dynamic engagement with the City of Boston and the world. With this mission in mind, please respond to one of the following two questions in 300 words or less. What about being a student at BU most excites you? How do you hope to contribute to our campus community?"
        ],
        "prompt": "Boston University is dedicated to our founding principles: 'that higher education should be accessible to all and that research, scholarship, artistic creation, and professional practice should be conducted in the service of the wider community—local and international.' These principles endure in the University’s insistence on the value of diversity in its tradition and standards of excellence and its dynamic engagement with the City of Boston and the world. With this mission in mind, please respond to one of the following two questions in 300 words or less. — Reflect on a social or community issue that deeply resonates with you. Why is it important to you, and how have you been involved in addressing or raising awareness about it?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "Boston University is dedicated to our founding principles: 'that higher education should be accessible to all and that research, scholarship, artistic creation, and professional practice should be conducted in the service of the wider community—local and international.' These principles endure in the University’s insistence on the value of diversity in its tradition and standards of excellence and its dynamic engagement with the City of Boston and the world. With this mission in mind, please respond to one of the following two questions in 300 words or less. Reflect on a social or community issue that deeply resonates with you. Why is it important to you, and how have you been involved in addressing or raising awareness about it?"
        ],
        "prompt": "Boston University is dedicated to our founding principles: 'that higher education should be accessible to all and that research, scholarship, artistic creation, and professional practice should be conducted in the service of the wider community—local and international.' These principles endure in the University’s insistence on the value of diversity in its tradition and standards of excellence and its dynamic engagement with the City of Boston and the world. With this mission in mind, please respond to one of the following two questions in 300 words or less. — What about being a student at BU most excites you? How do you hope to contribute to our campus community?",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "brandeis_university": {
    "Name": "Brandeis University",
    "applications": {
      "appType": [
        "Brandeis Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Brandeis"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "What excites you the most about being an international student at Brandeis University? ",
        "status": "Optional",
        "wordCount": "250"
      },
      {
        "category": "Diversity",
        "options": "None",
        "prompt": "Brandeis was established 75 years ago to address antisemitism, racism, and gender discrimination in higher education, and today, the university remains dedicated to its founding values of inclusivity and justice. How has your educational experience shaped your perspective on these values?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "brown_university": {
    "Name": "Brown University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Universal College App",
        "QuestBridge App",
        "Brown Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Brown"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Brown’s Open Curriculum allows students to explore broadly while also diving deeply into their academic pursuits. Tell us about any academic interests that excite you, and how you might pursue them at Brown.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "What inspires you",
          "Challenge"
        ],
        "options": [
          "None"
        ],
        "prompt": "Students entering Brown often find that making their home on College Hill naturally invites reflection on where they came from. Share how an aspect of your growing up has inspired or challenged you, and what unique contributions this might allow you to make to the Brown community.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "Brown students care deeply about their work and the world around them. Students find contentment, satisfaction, and meaning in daily interactions and major discoveries. Whether big or small, mundane or spectacular, tell us about something that brings you joy.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [
          "None"
        ],
        "prompt": "What three words best describe you?",
        "status": "Mandatory",
        "wordCount": "3"
      },
      {
        "category": [
          "Activity"
        ],
        "options": [
          "None"
        ],
        "prompt": "What is your most meaningful extracurricular commitment, and what would you like us to know about it?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "If you could teach a class on any one thing, whether academic or otherwise, what would it be?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Short Answer",
          "Why this College"
        ],
        "options": [
          "None"
        ],
        "prompt": "In one sentence, Why Brown?",
        "status": "Mandatory",
        "wordCount": "50"
      }
    ]
  },
  "bucknell_university": {
    "Name": "Bucknell University",
    "applications": {
      "appType": [
        "Bucknell Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Bucknell"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest",
          "Why Bucknell"
        ],
        "options": "None",
        "prompt": "Please explain your interest in your first-choice major/undecided status and your second-choice major (should you opt to list one) and why you would choose Bucknell University to pursue your interest(s).",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "butler_university": {
    "Name": "Butler University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Butler Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Butler"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college",
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Briefly describe your reasons for selecting your chosen academic major(s) and how you believe Butler will help you achieve your related career goals upon graduation.",
        "status": "Mandatory",
        "wordCount": "100"
      }
    ]
  },
  "carnegie_mellon_university": {
    "Name": "Carnegie Mellon University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Carnegie Mellon Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Carnegie Mellon"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "Many students pursue college for a specific degree, career opportunity or personal goal. Whichever it may be, learning will be critical to achieve your ultimate goal. As you think ahead to the process of learning during your college years, how will you define a successful college experience?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "What inspires you",
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Most students choose their intended major or area of study based on a passion or inspiration that’s developed over time – what passion or inspiration led you to choose this area of study?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "None"
        ],
        "prompt": "Consider your application as a whole. What do you personally want to emphasize about your application for the admission committee’s consideration? Highlight something that’s important to you or something you haven’t had a chance to share. Tell us, don’t show us (no websites please).",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "case_western_reserve_university": {
    "Name": "Case Western Reserve University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Case Western Application",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Case Western"
      ]
    },
    "prompts": [
      {
        "category": [
          "Activities",
          "Extended Essay"
        ],
        "options": [
          "None"
        ],
        "prompt": "In the college application process, you are constantly prompted for a list of your achievements, awards, and accomplishments. While this information is useful to us, we are interested in hearing more about you. Describe an event, achievement, or experience of which you are particularly proud but that will not show up on a resume, may not garner any recognition, and does not appear anywhere else on your admission application.",
        "status": "Optional",
        "wordCount": "750"
      },
      {
        "category": [
          "Academic Interest",
          "Extended Essay"
        ],
        "options": [
          "None"
        ],
        "prompt": "By applying to the Pre-Professional Scholars Program, you are applying to gain admission to professional school earlier than students who apply in the traditional way. Please indicate why you’re interested in your chosen profession. How do you see yourself being particularly suited to this field? What events and/or experiences have led you to your choice?",
        "status": "Optional",
        "wordCount": "500"
      }
    ]
  },
  "chapman_university": {
    "Name": "Chapman University",
    "applications": {
      "appType": [
        "Common App",
        "Chapman Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Chapman"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [],
        "prompt": "Out of the thousands of universities and colleges, why are you interested in attending Chapman?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Out of the thousands of universities and colleges, why are you interested in attending Chapman?",
          "Chapman University encourages academic exploration through our dynamic liberal arts curriculum. It’s okay to be unsure of what you might want to major in. Please tell us about the academic areas that interest you currently."
        ],
        "prompt": "Please tell us about your interest in the major you selected.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Out of the thousands of universities and colleges, why are you interested in attending Chapman?",
          "Please tell us about your interest in the major you selected."
        ],
        "prompt": "Chapman University encourages academic exploration through our dynamic liberal arts curriculum. It’s okay to be unsure of what you might want to major in. Please tell us about the academic areas that interest you currently.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Opinions"
        ],
        "options": [],
        "prompt": "Personal Values: Our committee would like to hear about a personal experience or lesson that has helped you better understand who you are now and/or appreciate a perspective different from your own. How would you utilize this understanding to contribute to the values and welcoming fabric of our campus community?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "Personal Growth: Part of the Chapman experience is to help students expand their perspectives. How do you plan to develop yourself during your time at Chapman?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What is your dream job?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What song should we be listening to while reading your application?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "Name one dish you would cook for our admission team.",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What is your favorite subject?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What is the top thing on your bucket list?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What makes you happy?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "If Chapman’s admission team came to visit your hometown, what site would you take them to?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What can you give a 30-minute presentation on without any preparation?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What is something you have always wanted to learn but never had the chance to?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What are the best words of advice you have received?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [],
        "prompt": "What is a family tradition that you want to continue?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      }
    ]
  },
  "claremont_mckenna_college": {
    "Name": "Claremont McKenna College",
    "applications": {
      "appType": [
        "Caremont McKenna Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Claremont McKenna"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "CMC’s mission is to prepare students for thoughtful and productive lives and responsible leadership in business, government, and the professions. With this mission in mind, please explain why you want to attend Claremont McKenna College.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Describe a time when engaging with someone about a specific topic resulted in you changing your attitude, belief, or behavior, or you changed the belief or behavior of someone else. What was the change that occurred for you, and what facilitated that change? What did you learn from that experience, and how has it informed how you engage with others?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "college_of_william_and_mary": {
    "Name": "College of William & Mary",
    "applications": {
      "appType": [
        "William & Mary Application",
        "Common App",
        "Coalition App",
        "Questbridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "William & Mary"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community"
        ],
        "options": [
          "Share more about a personal academic interest or career goal.",
          "How has your family, culture and/or background shaped your lived experience?",
          "What led to your interest in William & Mary?",
          "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
          "If we visited your town, what would you want to show us?"
        ],
        "prompt": "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
          "How has your family, culture and/or background shaped your lived experience?",
          "What led to your interest in William & Mary?",
          "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
          "If we visited your town, what would you want to show us?"
        ],
        "prompt": "Share more about a personal academic interest or career goal.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Experiences"
        ],
        "options": [
          "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
          "Share more about a personal academic interest or career goal.",
          "What led to your interest in William & Mary?",
          "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
          "If we visited your town, what would you want to show us?"
        ],
        "prompt": "How has your family, culture and/or background shaped your lived experience?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
          "Share more about a personal academic interest or career goal.",
          "What led to your interest in William & Mary?",
          "How has your family, culture and/or background shaped your lived experience?",
          "If we visited your town, what would you want to show us?"
        ],
        "prompt": "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
          "Share more about a personal academic interest or career goal.",
          "How has your family, culture and/or background shaped your lived experience?",
          "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
          "If we visited your town, what would you want to show us?"
        ],
        "prompt": "What led to your interest in William & Mary?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Are there any particular communities that are important to you, and how do you see yourself being a part of our community?",
          "Share more about a personal academic interest or career goal.",
          "How has your family, culture and/or background shaped your lived experience?",
          "Tell us about a challenge or adversity you’ve experienced and how that has impacted you as an individual.",
          "What led to your interest in William & Mary?"
        ],
        "prompt": "If we visited your town, what would you want to show us?",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "college_of_wooster": {
    "Name": "College of Wooster",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Wooster Priority Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Wooster"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Why are you interested in The College of Wooster?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "columbia_university": {
    "Name": "Columbia University",
    "applications": {
      "appType": [
        "Columbia Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Columbia"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "For the list question that follows, there is a 100 word maximum. Please refer to the below guidance when answering this question: Your response should be a list of items separated by commas or semicolons. Items do not have to be numbered or in any specific order. It is not necessary to italicize or underline titles of books or other publications. No author names, subtitles or explanatory remarks are needed. List a selection of texts, resources and outlets that have contributed to your intellectual development outside of academic courses, including but not limited to books, journals, websites, podcasts, essays, plays, presentations, videos, museums and other content that you enjoy.",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Community",
          "Experiences"
        ],
        "options": "None",
        "prompt": "A hallmark of the Columbia experience is being able to learn and thrive in an equitable and inclusive community with a wide range of perspectives. Tell us about an aspect of your own perspective, viewpoint or lived experience that is important to you, and describe how it has shaped the way you would learn from and contribute to Columbia’s diverse and collaborative community.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Challenge",
        "options": "None",
        "prompt": "In college/university, students are often challenged in ways that they could not predict or anticipate. It is important to us, therefore, to understand an applicant’s ability to navigate through adversity. Please describe a barrier or obstacle you have faced and discuss the personal qualities, skills or insights you have developed as a result.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "Why are you interested in attending Columbia University? We encourage you to consider the aspect(s) that you find unique and compelling about Columbia.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Academic interest",
        "options": "None",
        "prompt": "What attracts you to your preferred areas of study at Columbia College or Columbia Engineering?",
        "status": "Mandatory",
        "wordCount": "150"
      }
    ]
  },
  "cornell_university": {
    "Name": "Cornell University",
    "applications": {
      "appType": [
        "Common App",
        "QuestBridge App",
        "Cornell Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Cornell"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community"
        ],
        "options": [],
        "prompt": "We all contribute to, and are influenced by, the communities that are meaningful to us. Share how you’ve been shaped by one of the communities you belong to. Remember that this essay is about you and your lived experience. Define community in the way that is most meaningful to you. Some examples of community you might choose from are: family, school, shared interest, virtual, local, global, cultural.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Engineering: Fundamentally, engineering is the application of math, science, and technology to solve complex problems. Why do you want to study engineering?",
          "College of Arts & Sciences: At the College of Arts and Sciences, curiosity will be your guide. Discuss how your passion for learning is shaping your academic journey, and what areas of study or majors excite you and why.",
          "Cornell Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy? Drawing on your experiences, tell us about why you are interested in your chosen major and how attending the Brooks School will help you achieve your life goals.",
          "College of Architecture, Art, and Planning: How do your interests directly connect with your intended major at the College of Architecture, Art, and Planning (AAP)? Why architecture (B.Arch), art (BFA), or urban and regional studies (URS)?",
          "SC Johnson College of Business: What kind of a business student are you? Using your personal, academic, or volunteer/work experiences, describe the topics or issues that you care about and why they are important to you.",
          "College of Human Ecology: How has your decision to apply to the College of Human Ecology (CHE) been shaped and informed by your related experiences? How will what you learn through CHE and your chosen major impact your goals and plans for the future?"
        ],
        "prompt": "College of Agriculture and Life Sciences: Why are you drawn to studying the major you have selected and specifically, why do you want to pursue this major at Cornell CALS? You should share how your current interests, related experiences, and/or goals influenced your choice.",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Arts & Sciences: Discuss how your passion for learning is shaping your academic journey.",
          "Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy?",
          "College of Architecture, Art, and Planning: How do your interests connect with your intended major?",
          "SC Johnson College of Business: What kind of business student are you?",
          "College of Human Ecology: How has your decision to apply to CHE been shaped by your experiences?"
        ],
        "prompt": "Fundamentally, engineering is the application of math, science, and technology to solve complex problems. Why do you want to study engineering?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Engineering: Why do you want to study engineering?",
          "College of Arts & Sciences: Discuss how your passion for learning is shaping your academic journey.",
          "Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy?",
          "SC Johnson College of Business: What kind of business student are you?",
          "College of Human Ecology: How has your decision to apply to CHE been shaped by your experiences?"
        ],
        "prompt": "College of Architecture, Art, and Planning: How do your interests directly connect with your intended major at the College of Architecture, Art, and Planning (AAP)? Why architecture (B.Arch), art (BFA), or urban and regional studies (URS)? B. Arch applicants, please provide an example of how a creative project or passion sparks your motivation to pursue a 5-year professional degree program. BFA applicants may want to consider how they could integrate a range of interests and available resources at Cornell into a coherent art practice. URS students may want to emphasize their enthusiasm and depth of interest in the study of urban and regional issues.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Engineering: Why do you want to study engineering?",
          "Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy?",
          "College of Architecture, Art, and Planning: How do your interests connect with your intended major?",
          "SC Johnson College of Business: What kind of business student are you?",
          "College of Human Ecology: How has your decision to apply to CHE been shaped by your experiences?"
        ],
        "prompt": "College of Arts & Sciences: At the College of Arts and Sciences, curiosity will be your guide. Discuss how your passion for learning is shaping your academic journey, and what areas of study or majors excite you and why. Your response should convey how your interests align with the College, and how you would take advantage of the opportunities and curriculum in Arts and Sciences.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Engineering: Why do you want to study engineering?",
          "College of Arts & Sciences: Discuss how your passion for learning is shaping your academic journey.",
          "College of Architecture, Art, and Planning: How do your interests connect with your intended major?",
          "SC Johnson College of Business: What kind of business student are you?",
          "College of Human Ecology: How has your decision to apply to CHE been shaped by your experiences?"
        ],
        "prompt": "Cornell Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy? Drawing on your experiences, tell us about why you are interested in your chosen major and how attending the Brooks School will help you achieve your life goals.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Engineering: Why do you want to study engineering?",
          "College of Arts & Sciences: Discuss how your passion for learning is shaping your academic journey.",
          "Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy?",
          "College of Architecture, Art, and Planning: How do your interests connect with your intended major?",
          "College of Human Ecology: How has your decision to apply to CHE been shaped by your experiences?"
        ],
        "prompt": "Cornell SC Johnson College of Business: What kind of a business student are you? Using your personal, academic, or volunteer/work experiences, describe the topics or issues that you care about and why they are important to you. Your response should convey how your interests align with the school to which you are applying within the Cornell SC Johnson College of Business (Charles H. Dyson School of Applied Economics and Management or the Cornell Peter and Stephanie Nolan School of Hotel Administration).",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "College of Agriculture and Life Sciences (CALS): Why are you drawn to studying the major you have selected?",
          "College of Engineering: Why do you want to study engineering?",
          "College of Arts & Sciences: Discuss how your passion for learning is shaping your academic journey.",
          "Jeb E. Brooks School of Public Policy: Why are you drawn to studying public policy?",
          "College of Architecture, Art, and Planning: How do your interests connect with your intended major?",
          "SC Johnson College of Business: What kind of business student are you?"
        ],
        "prompt": "College of Human Ecology: How has your decision to apply to the College of Human Ecology (CHE) been shaped and informed by your related experiences? How will what you learn through CHE and your chosen major impact your goals and plans for the future? Your response should demonstrate how your interests and aspirations align with CHE’s programs and mission.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Acadmic Interest"
        ],
        "options": [],
        "prompt": "Engineering Applicants: Why do you think you would love to study at Cornell Engineering?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Other"
        ],
        "options": [],
        "prompt": "Engineering Applicants: What brings you joy?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [],
        "prompt": "Engineering Applicants: What do you believe you will contribute to the Cornell Engineering community beyond what you’ve already detailed in your application? What unique voice will you bring? (100 words)",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Activity"
        ],
        "options": [],
        "prompt": "Engineering Applicants: What is one activity, club, team, organization, work/volunteer experience or family responsibility that is especially meaningful to you? (100 words)",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Other"
        ],
        "options": [],
        "prompt": "Engineering Applicants: What is one award you have received or achievement you have attained that has meant the most to you? (100 words)",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Community"
        ],
        "options": [],
        "prompt": "Optional for CALS Applicants: At Cornell CALS, we aim to leave the world better than we found it, so we seek out those who are passionate about serving the public good. Please elaborate on an experience where you were able to have a meaningful impact on people, a community, and/or an environment of importance to you. (100 words)",
        "status": "Optional",
        "wordCount": "100"
      },
      {
        "category": [
          "Other"
        ],
        "options": [],
        "prompt": "Optional for CALS Applicants: Given our agricultural history and commitment to educating the next generation of agriculturalists, please share if you have a background or interest in agriculture.",
        "status": "Optional",
        "wordCount": "100"
      }
    ]
  },
  "dartmouth_college": {
    "Name": "Dartmouth College",
    "applications": {
      "appType": [
        "Dartmouth Application",
        "Common App",
        "QuestBridge App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Dartmouth"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "As you seek admission to Dartmouth’s Class of 2029, what aspects of the college’s academic program, community, and/or campus environment attract your interest? How is Dartmouth a good fit for you?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Experiences",
        "options": "“Be yourself,” Oscar Wilde advised. “Everyone else is taken.” Introduce yourself.",
        "prompt": "There is a Quaker saying: Let your life speak. Describe the environment in which you were raised and the impact it has had on the person you are today.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": "There is a Quaker saying: Let your life speak. Describe the environment in which you were raised and the impact it has had on the person you are today.",
        "prompt": "“Be yourself,” Oscar Wilde advised. “Everyone else is taken.” Introduce yourself.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "What inspires you",
        "options": [
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "Celebrate your nerdy side.",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?",
          "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?"
        ],
        "prompt": "What excites you?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": [
          "What excites you?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "Celebrate your nerdy side.",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?",
          "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?"
        ],
        "prompt": "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": [
          "What excites you?",
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "Celebrate your nerdy side.",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?",
          "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?"
        ],
        "prompt": "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Opinions",
        "options": [
          "What excites you?",
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "Celebrate your nerdy side.",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?",
          "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?"
        ],
        "prompt": "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": [
          "What excites you?",
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "Celebrate your nerdy side.",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?"
        ],
        "prompt": "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Diversity",
        "options": [
          "What excites you?",
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "Celebrate your nerdy side.",
          "Buddy Teevens ’79 was a legendary and much-beloved coach at Dartmouth. He often told parents: “Your son will be a great football player when it’s football time, a great student when it’s academic time, and a great person all of the time.” If Coach Teevens had said that to you, what would it mean to be “a great person”?"
        ],
        "prompt": "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": [
          "What excites you?",
          "Labor leader and civil rights activist Dolores Huerta recommended a life of purpose. “We must use our lives to make the world a better place to live, not just to acquire things,” she said. “That is what we are put on the earth for.” In what ways do you hope to make—or are you already making—an impact? Why? How?",
          "In “Oh, The Places You’ll Go,” Dr. Seuss invites us to “Think and wonder. Wonder and think.” Imagine your anticipated academic major: How does that course of study sync with Dr. Seuss’s advice to you?",
          "The social and family interactions of wild chimpanzees have been the focus of Dame Jane Goodall’s research for decades. Her understanding of animal behavior prompted the English primatologist to see a lesson for human communities as well: “Change happens by listening and then starting a dialogue with the people who are doing something you don’t believe is right.” Channel Dame Goodall: Tell us about a moment when you engaged in a difficult conversation or encountered someone with an opinion or perspective that was different from your own. How did you find common ground?",
          "“It’s not easy being green…” was the frequent refrain of Kermit the Frog. How has difference been a part of your life, and how have you embraced it as part of your identity, outlook, or sense of purpose?"
        ],
        "prompt": "Celebrate your nerdy side.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "duke_university": {
    "Name": "Duke University",
    "applications": {
      "appType": [
        "Common App",
        "Duke Application",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Duke"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "What is your sense of Duke as a university and a community, and why do you consider it a good match for you? If there’s something in particular about our offerings that attracts you, feel free to share that as well.",
        "status": "Mandatory",
        "wordCount": 250
      },
      {
        "category": "Diversity",
        "options": [
          "We believe a wide range of personal perspectives, beliefs, and lived experiences are essential to making Duke a vibrant and meaningful living and learning community. Feel free to share with us anything in this context that might help us better understand you and what you might bring to our community.",
          "Tell us about an experience in the past year or two that reflects your imagination, creativity or intellect.",
          "We believe there is benefit in sharing or questioning our beliefs or values; who do you agree with on the big important things, or who do you have your most interesting disagreements with? What are you agreeing or disagreeing about?",
          "We recognize that “fitting in” in all the contexts we live in can sometimes be difficult. Duke values all kinds of differences and believes they make our community better. Feel free to tell us any ways in which you’re different, and how that has affected you or what it means to you."
        ],
        "prompt": "We believe a wide range of personal perspectives, beliefs, and lived experiences are essential to making Duke a vibrant and meaningful living and learning community. Feel free to share with us anything in this context that might help us better understand you and what you might bring to our community.",
        "status": "Optional",
        "wordCount": 250
      },
      {
        "category": "Experience",
        "options": [
          "We believe a wide range of personal perspectives, beliefs, and lived experiences are essential to making Duke a vibrant and meaningful living and learning community. Feel free to share with us anything in this context that might help us better understand you and what you might bring to our community.",
          "Tell us about an experience in the past year or two that reflects your imagination, creativity or intellect.",
          "We believe there is benefit in sharing or questioning our beliefs or values; who do you agree with on the big important things, or who do you have your most interesting disagreements with? What are you agreeing or disagreeing about?",
          "We recognize that “fitting in” in all the contexts we live in can sometimes be difficult. Duke values all kinds of differences and believes they make our community better. Feel free to tell us any ways in which you’re different, and how that has affected you or what it means to you."
        ],
        "prompt": "Tell us about an experience in the past year or two that reflects your imagination, creativity or intellect.",
        "status": "Optional",
        "wordCount": 250
      },
      {
        "category": "Other",
        "options": [
          "We believe a wide range of personal perspectives, beliefs, and lived experiences are essential to making Duke a vibrant and meaningful living and learning community. Feel free to share with us anything in this context that might help us better understand you and what you might bring to our community.",
          "Tell us about an experience in the past year or two that reflects your imagination, creativity or intellect.",
          "We believe there is benefit in sharing or questioning our beliefs or values; who do you agree with on the big important things, or who do you have your most interesting disagreements with? What are you agreeing or disagreeing about?",
          "We recognize that “fitting in” in all the contexts we live in can sometimes be difficult. Duke values all kinds of differences and believes they make our community better. Feel free to tell us any ways in which you’re different, and how that has affected you or what it means to you."
        ],
        "prompt": "We believe there is benefit in sharing or questioning our beliefs or values; who do you agree with on the big important things, or who do you have your most interesting disagreements with? What are you agreeing or disagreeing about?",
        "status": "Optional",
        "wordCount": 250
      },
      {
        "category": "Diversity",
        "options": [
          "We believe a wide range of personal perspectives, beliefs, and lived experiences are essential to making Duke a vibrant and meaningful living and learning community. Feel free to share with us anything in this context that might help us better understand you and what you might bring to our community.",
          "Tell us about an experience in the past year or two that reflects your imagination, creativity or intellect.",
          "We believe there is benefit in sharing or questioning our beliefs or values; who do you agree with on the big important things, or who do you have your most interesting disagreements with? What are you agreeing or disagreeing about?",
          "We recognize that “fitting in” in all the contexts we live in can sometimes be difficult. Duke values all kinds of differences and believes they make our community better. Feel free to tell us any ways in which you’re different, and how that has affected you or what it means to you."
        ],
        "prompt": "We recognize that “fitting in” in all the contexts we live in can sometimes be difficult. Duke values all kinds of differences and believes they make our community better. Feel free to tell us any ways in which you’re different, and how that has affected you or what it means to you.",
        "status": "Optional",
        "wordCount": 250
      },
      {
        "category": "Diversity",
        "options": "None",
        "prompt": "Duke’s commitment to inclusion and belonging includes sexual orientation, gender identity, and gender expression. Feel free to share with us more about how your identity in this context has meaning for you as an individual or as a member of a community.",
        "status": "Optional",
        "wordCount": 250
      }
    ]
  },
  "elon_university": {
    "Name": "Elon University",
    "applications": {
      "appType": [],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": []
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "What aspect of your identity do you find most meaningful, and why?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": [
          "None"
        ],
        "prompt": "Name three songs from your perfect playlist. Provide song titles and artists for each song. (75 characters per title/artist)",
        "status": "Mandatory",
        "wordCount": "450 Characters"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "Tell us your top 5. Take this opportunity to let Elon Admissions know more about you. Explain why these are your top 5.",
        "status": "Mandatory",
        "wordCount": "150"
      }
    ]
  },
  "emerson_college": {
    "Name": "Emerson College",
    "applications": {
      "appType": [
        "Emerson Application",
        "Common App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Emerson"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [],
        "prompt": "As you know, the academic programs at Emerson College are focused on communication and the arts. Please tell us what influenced you to select your major. If you’re undecided about your major, what attracted you to Emerson’s programs? Please be brief.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "At its best, how does community benefit the individual, the whole, or both?"
        ],
        "prompt": "Much of the work that students do at Emerson College is a form of storytelling. If you were to write the story of your life until now, what would you title it and why?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Much of the work that students do at Emerson College is a form of storytelling. If you were to write the story of your life until now, what would you title it and why?"
        ],
        "prompt": "At its best, how does community benefit the individual, the whole, or both?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Extended Essay"
        ],
        "options": [],
        "prompt": "We often use metaphors to help us understand our world and persuade others. Write about a metaphor that you think is powerful, and explore its potential to be helpful and/or harmful in your thinking.",
        "status": "Optional",
        "wordCount": "600"
      }
    ]
  },
  "emory_university": {
    "Name": "Emory University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "QuestBridge App",
        "Emory Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Emory"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "What academic areas are you interested in exploring in college?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Experience",
          "Opinions"
        ],
        "options": [
          "Which book, character, song, monologue, or piece of work (fiction or non-fiction) seems made for you? Why?",
          "Emory University’s core mission calls for service to humanity. Share how you might personally contribute to this mission.",
          "Emory University has a strong commitment to building community. Tell us about a community you have been part of where your participation helped to change or shape the community for the better."
        ],
        "prompt": "Reflect on a personal experience where you intentionally expanded your cultural awareness.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Reflect on a personal experience where you intentionally expanded your cultural awareness.",
          "Emory University’s core mission calls for service to humanity. Share how you might personally contribute to this mission.",
          "Emory University has a strong commitment to building community. Tell us about a community you have been part of where your participation helped to change or shape the community for the better."
        ],
        "prompt": "Which book, character, song, monologue, or piece of work (fiction or non-fiction) seems made for you? Why?",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Reflect on a personal experience where you intentionally expanded your cultural awareness.",
          "Which book, character, song, monologue, or piece of work (fiction or non-fiction) seems made for you? Why?",
          "Emory University has a strong commitment to building community. Tell us about a community you have been part of where your participation helped to change or shape the community for the better."
        ],
        "prompt": "Emory University’s core mission calls for service to humanity. Share how you might personally contribute to this mission.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Reflect on a personal experience where you intentionally expanded your cultural awareness.",
          "Emory University’s core mission calls for service to humanity. Share how you might personally contribute to this mission.",
          "Which book, character, song, monologue, or piece of work (fiction or non-fiction) seems made for you? Why?"
        ],
        "prompt": "Emory University has a strong commitment to building community. Tell us about a community you have been part of where your participation helped to change or shape the community for the better.",
        "status": "Mandatory",
        "wordCount": "150"
      }
    ]
  },
  "fordham_university": {
    "Name": "Fordham University",
    "applications": {
      "appType": [
        "Common App",
        "Fordham Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Fordham"
      ]
    },
    "prompts": [
      {
        "category": [
          "Opinions"
        ],
        "options": [
          "Fordham, as a Jesuit university, recognizes the dignity, uniqueness and potential of each person. Describe how you would contribute to our campus community as an actively engaged learner and leader.",
          "Our motto is “New York is my campus, Fordham is my school.” New York City is a diverse and global city that provides Fordham students with a special kind of educational experience. What has prepared you to embrace the unique opportunity of living and learning in New York City?"
        ],
        "prompt": "At Fordham, we expect students to care for and engage with their communities and be active citizens for positive change. Please share an experience you had that caused you to develop a new perspective, change your point of view, and/or empower you to take an action or be courageous.",
        "status": "Optional",
        "wordCount": "300"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "At Fordham, we expect students to care for and engage with their communities and be active citizens for positive change. Please share an experience you had that caused you to develop a new perspective, change your point of view, and/or empower you to take an action or be courageous.",
          "Our motto is “New York is my campus, Fordham is my school.” New York City is a diverse and global city that provides Fordham students with a special kind of educational experience. What has prepared you to embrace the unique opportunity of living and learning in New York City?"
        ],
        "prompt": "Fordham, as a Jesuit university, recognizes the dignity, uniqueness and potential of each person. Describe how you would contribute to our campus community as an actively engaged learner and leader.",
        "status": "Optional",
        "wordCount": "300"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "At Fordham, we expect students to care for and engage with their communities and be active citizens for positive change. Please share an experience you had that caused you to develop a new perspective, change your point of view, and/or empower you to take an action or be courageous.",
          "Fordham, as a Jesuit university, recognizes the dignity, uniqueness and potential of each person. Describe how you would contribute to our campus community as an actively engaged learner and leader."
        ],
        "prompt": "Our motto is “New York is my campus, Fordham is my school.” New York City is a diverse and global city that provides Fordham students with a special kind of educational experience. What has prepared you to embrace the unique opportunity of living and learning in New York City?",
        "status": "Optional",
        "wordCount": "300"
      }
    ]
  },
  "george_washington_university": {
    "Name": "George Washington University",
    "applications": {
      "appType": [
        "Common App",
        "Questbridge",
        "GW Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "GW"
      ]
    },
    "prompts": [
      {
        "category": [
          "Extended Essay",
          "Other"
        ],
        "options": [
          "The George Washington University encourages students to think critically and to challenge the status quo. Thus, civil discourse is a key characteristic of our community. Describe a time when you engaged others in meaningful dialogue around an issue that was important to you. Did this exchange create change, new perspectives, or deeper relationships?"
        ],
        "prompt": "At the George Washington University, our students frequently interact with policymakers and world leaders. These experiences and those of our alumni can shape the future of global affairs. If you had the power to change the course of history in your community or the world, what would you do and why?",
        "status": "Optional",
        "wordCount": "500"
      },
      {
        "category": [
          "Extended Essay",
          "Opinions"
        ],
        "options": [
          "At the George Washington University, our students frequently interact with policymakers and world leaders. These experiences and those of our alumni can shape the future of global affairs. If you had the power to change the course of history in your community or the world, what would you do and why?"
        ],
        "prompt": "The George Washington University encourages students to think critically and to challenge the status quo. Thus, civil discourse is a key characteristic of our community. Describe a time when you engaged others in meaningful dialogue around an issue that was important to you. Did this exchange create change, new perspectives, or deeper relationships?",
        "status": "Optional",
        "wordCount": "500"
      }
    ]
  },
  "georgetown_university": {
    "Name": "Georgetown University",
    "applications": {
      "appType": [
        "Georgetown Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "Georgetown"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "Please elaborate on any special talents or skills you would like to highlight.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Activity",
        "options": "None",
        "prompt": "Briefly discuss the significance to you of the school or summer activity in which you have been most involved.",
        "status": "Mandatory",
        "wordCount": "Roughly 250"
      },
      {
        "category": "Extended Essay",
        "options": "None",
        "prompt": "As Georgetown is a diverse community, the Admissions Committee would like to know more about you in your own words. Please submit a brief personal or creative essay which you feel best describes you and reflects on your own background, identity, skills, and talents.",
        "status": "Mandatory",
        "wordCount": "Roughly 500"
      },
      {
        "category": "Academic Interest",
        "options": [
          "School of Health: Describe the factors that have influenced your interest in studying health care at Georgetown University. Please specifically address your intended major (Global Health, Health Care Management & Policy, or Human Science).",
          "School of Nursing: Describe the factors that have influenced your interest in studying your intended major, Nursing.",
          "Walsh School of Foreign Service: The Walsh School of Foreign Service was founded more than a century ago to prepare generations of leaders to solve global problems. What is motivating you to dedicate your undergraduate studies to a future in service to the world?",
          "McDonough School of Business: The McDonough School of Business is a national and global leader in providing graduates with essential ethical, analytical, financial and global perspectives. Please discuss your motivations for studying business at Georgetown."
        ],
        "prompt": "Georgetown College of Arts and Sciences: A liberal arts education from the College of Arts & Sciences involves encounters with new concepts and modes of inquiry. Describe something (a class, a book, an event, etc.) that changed your thinking. (Applicants to the sciences, mathematics, public policy or languages are encouraged to include examples related to that field.)",
        "status": "Mandatory",
        "wordCount": "Roughly 500"
      },
      {
        "category": "Academic Interest",
        "options": [
          "Georgetown College of Arts and Sciences: A liberal arts education from the College of Arts & Sciences involves encounters with new concepts and modes of inquiry. Describe something (a class, a book, an event, etc.) that changed your thinking. (Applicants to the sciences, mathematics, public policy or languages are encouraged to include examples related to that field.)",
          "School of Nursing: Describe the factors that have influenced your interest in studying your intended major, Nursing.",
          "Walsh School of Foreign Service: The Walsh School of Foreign Service was founded more than a century ago to prepare generations of leaders to solve global problems. What is motivating you to dedicate your undergraduate studies to a future in service to the world?",
          "McDonough School of Business: The McDonough School of Business is a national and global leader in providing graduates with essential ethical, analytical, financial and global perspectives. Please discuss your motivations for studying business at Georgetown."
        ],
        "prompt": "School of Health: Describe the factors that have influenced your interest in studying health care at Georgetown University. Please specifically address your intended major (Global Health, Health Care Management & Policy, or Human Science).",
        "status": "Mandatory",
        "wordCount": "Roughly 500"
      },
      {
        "category": "Academic Interest",
        "options": [
          "Georgetown College of Arts and Sciences: A liberal arts education from the College of Arts & Sciences involves encounters with new concepts and modes of inquiry. Describe something (a class, a book, an event, etc.) that changed your thinking. (Applicants to the sciences, mathematics, public policy or languages are encouraged to include examples related to that field.)",
          "School of Health: Describe the factors that have influenced your interest in studying health care at Georgetown University. Please specifically address your intended major (Global Health, Health Care Management & Policy, or Human Science).",
          "School of Nursing: Describe the factors that have influenced your interest in studying your intended major, Nursing.",
          "Walsh School of Foreign Service: The Walsh School of Foreign Service was founded more than a century ago to prepare generations of leaders to solve global problems. What is motivating you to dedicate your undergraduate studies to a future in service to the world?"
        ],
        "prompt": "McDonough School of Business: The McDonough School of Business is a national and global leader in providing graduates with essential ethical, analytical, financial and global perspectives. Please discuss your motivations for studying business at Georgetown.",
        "status": "Mandatory",
        "wordCount": "Roughly 500"
      }
    ]
  },
  "georgia_tech": {
    "Name": "Georgia Institute of Technology (Georgia Tech)",
    "applications": {
      "appType": [
        "Georgia Tech Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Georgia Tech"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college",
          "Academic Interest"
        ],
        "options": "None",
        "prompt": "Why do you want to study your chosen major specifically at Georgia Tech?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "harvard_university": {
    "Name": "Harvard University",
    "applications": {
      "appType": [
        "Harvard Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Harvard"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Diversity"
        ],
        "options": "None",
        "prompt": "Harvard has long recognized the importance of enrolling a diverse student body. How will the life experiences that shape who you are today enable you to contribute to Harvard?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Opinions",
        "options": "None",
        "prompt": "Describe a time when you strongly disagreed with someone about an idea or issue. How did you communicate or engage with this person? What did you learn from this experience?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Top 3 things your roommates might like to know about you.",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "How do you hope to use your Harvard education in the future?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Activity",
        "options": "None",
        "prompt": "Briefly describe any of your extracurricular activities, employment experience, travel, or family responsibilities that have shaped who you are.",
        "status": "Mandatory",
        "wordCount": "100"
      }
    ]
  },
  "ithaca_college": {
    "Name": "Ithaca College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Ithaca College Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Ithaca College"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "We’re committed to supporting you in energizing your learning experiences so you can go further than you imagine. Please tell us why you selected-and how you see yourself growing in-this specific academic program.",
        "status": "Mandatory",
        "wordCount": "200"
      }
    ]
  },
  "johns_hopkins_university": {
    "Name": "Johns Hopkins University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Johns Hopkins Application",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Johns Hopkins"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "How has your life experience contributed to your personal story—your character, values, perspectives or skills—and what you want to pursue at Hopkins?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "lehigh_university": {
    "Name": "Lehigh University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Lehigh Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Lehigh"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "How did you first learn about Lehigh University and what motivated you to apply?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Experiences",
          "Diversity"
        ],
        "options": [
          "None"
        ],
        "prompt": "Our 10-year strategic plan, Inspiring the Future Makers, outlines three goals that articulate a vision for how we innovate, make an impact and do that work together—because together, we do better work. Reflect on how your personal background—be it academic, cultural, extracurricular, family, gender, racial, religious, or another aspect—will contribute to Lehigh’s aim to make it new, make a difference, (and/or) make it together.",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "loyola_marymount_university": {
    "Name": "Loyola Marymont University (LMU)",
    "applications": {
      "appType": [
        "LMU Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "LMU"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "An LMU education forms ethical leaders compelled to tackle the world’s most pressing challenges. How do your personal experiences and educational goals align with this mission?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "massachusetts_institute_of_technology": {
    "Name": "Massachusetts Institute of Technology (MIT)",
    "applications": {
      "appType": [
        "MIT Application",
        "QuestBridge App"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "MIT"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "We know you lead a busy life, full of activities, many of which are required of you. Tell us about something you do simply for the pleasure of it.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Academic Interest",
        "options": "None",
        "prompt": "What field of study appeals to you? Tell us more about why this field of study at MIT appeals to you.",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Experiences"
        ],
        "options": "None",
        "prompt": "How has the world you come from—including your opportunities, experiences, and challenges—shaped your dreams and aspirations?",
        "status": "Mandatory",
        "wordCount": "225"
      },
      {
        "category": "Community",
        "options": "None",
        "prompt": "MIT brings people with diverse backgrounds together to collaborate, from tackling the world’s biggest challenges to lending a helping hand. Describe one way you have collaborated with others to learn from them, with them, or contribute to your community together.",
        "status": "Mandatory",
        "wordCount": "225"
      },
      {
        "category": "Challenge",
        "options": "None",
        "prompt": "How did you manage a situation or challenge that you didn’t expect? What did you learn from it?",
        "status": "Mandatory",
        "wordCount": "225"
      }
    ]
  },
  "new_york_university": {
    "Name": "New York University (NYU)",
    "applications": {
      "appType": [
        "Common App",
        "NYU Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "NYU"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "In a world where disconnection seems to often prevail, we are looking for students who embody the qualities of bridge builders—students who can connect people, groups, and ideas to span divides, foster understanding, and promote collaboration within a dynamic, interconnected, and vibrant global academic community. We are eager to understand how your experiences have prepared you to build the bridges of the future. Please consider one or more of the following questions in your essay: What personal experiences or challenges have shaped you as a bridge builder? How have you been a bridge builder in your school, community, or personal life? What specific actions have you taken to build bridges between diverse groups, ideas, or cultures? How do you envision being a bridge builder during your time at our university and beyond?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "northeastern_university": {
    "Name": "Northeastern University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        ""
      ]
    },
    "prompts": []
  },
  "northwestern_university": {
    "Name": "Northwestern University",
    "applications": {
      "appType": [
        "Northwestern Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Northwestern"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Community"
        ],
        "options": "None",
        "prompt": "We want to be sure we’re considering your application in the context of your personal experiences: What aspects of your background, your identity, or your school, community, and/or household settings have most shaped how you see yourself engaging in Northwestern’s community, be it academically, extracurricularly, culturally, politically, socially, or otherwise?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Painting “The Rock” is a tradition at Northwestern that invites all forms of expression—students promote campus events or extracurricular groups, support social or activist causes, show their Wildcat spirit (what we call “Purple Pride”), celebrate their culture, and more. What would you paint on The Rock, and why?",
        "status": "Optional",
        "wordCount": "200"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Northwestern fosters a distinctively interdisciplinary culture. We believe discovery and innovation thrive at the intersection of diverse ideas, perspectives, and academic interests. Within this setting, if you could dream up an undergraduate class, research project, or creative effort (a start-up, a design prototype, a performance, etc.), what would it be? Who might be some ideal classmates or collaborators?",
        "status": "Optional",
        "wordCount": "200"
      },
      {
        "category": "Community",
        "options": "None",
        "prompt": "Community and belonging matter at Northwestern. Tell us about one or more communities, networks, or student groups you see yourself connecting with on campus.",
        "status": "Optional",
        "wordCount": "200"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Northwestern’s location is special: on the shore of Lake Michigan, steps from downtown Evanston, just a few miles from Chicago. What aspects of our location are most compelling to you, and why?",
        "status": "Optional",
        "wordCount": "200"
      },
      {
        "category": "Diversity",
        "options": "None",
        "prompt": "Northwestern is a place where people with diverse backgrounds from all over the world can study, live, and talk with one another. This range of experiences and viewpoints immeasurably enriches learning. How might your individual background contribute to this diversity of perspectives in Northwestern’s classrooms and around our campus?",
        "status": "Optional",
        "wordCount": "200"
      }
    ]
  },
  "occidental_college": {
    "Name": "Occidental College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Occidental Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Occidental"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "Oxy’s central mission emphasizes the value of community amidst diversity. What do you value in a community and how do you see your perspectives and life experiences enhancing it?",
          "Research is an integral part of an Oxy education. Imagine you were just awarded one of our research grants for a project of your choice. What are you researching and why?"
        ],
        "prompt": "Why are you applying to Occidental? Why do you think Occidental, and our location in Los Angeles, is the right place for you to pursue your interests?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Why are you applying to Occidental? Why do you think Occidental, and our location in Los Angeles, is the right place for you to pursue your interests?",
          "Research is an integral part of an Oxy education. Imagine you were just awarded one of our research grants for a project of your choice. What are you researching and why?"
        ],
        "prompt": "Oxy’s central mission emphasizes the value of community amidst diversity. What do you value in a community and how do you see your perspectives and life experiences enhancing it?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Why are you applying to Occidental? Why do you think Occidental, and our location in Los Angeles, is the right place for you to pursue your interests?",
          "Oxy’s central mission emphasizes the value of community amidst diversity. What do you value in a community and how do you see your perspectives and life experiences enhancing it?"
        ],
        "prompt": "Research is an integral part of an Oxy education. Imagine you were just awarded one of our research grants for a project of your choice. What are you researching and why?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "ohio_state_university": {
    "Name": "Ohio State University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        ""
      ]
    },
    "prompts": []
  },
  "pepperdine_university": {
    "Name": "Pepperdine University",
    "applications": {
      "appType": [
        "Common App",
        "Pepperdine Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Pepperdine"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community",
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Pepperdine is a Christian university where all are welcomed and encouraged to challenge each other in the pursuit of truth. Students, faculty, and staff members from all backgrounds participate in conversations of faith inside and outside of the classroom. Considering that Pepperdine is a Christian university, why are you interested in attending and how would you contribute to conversations of faith on campus?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "pitzer_college": {
    "Name": "Pitzer College",
    "applications": {
      "appType": [
        "Pitzer Application",
        "Common App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Pitzer"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college",
          "Extended Essay"
        ],
        "options": "At Pitzer College, five core values distinguish our approach to education: social responsibility, intercultural understanding, interdisciplinary learning, student engagement, and environmental sustainability. As agents of change, our students utilize these values to create solutions to our world’s challenges: Reflecting on your involvement throughout high school or within the community, how have you engaged with one of Pitzer’s core values?",
        "prompt": "At Pitzer College, five core values distinguish our approach to education: social responsibility, intercultural understanding, interdisciplinary learning, student engagement, and environmental sustainability. As agents of change, our students utilize these values to create solutions to our world’s challenges: Describe what you are looking for from your college experience and why Pitzer would be a good fit for you.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Extended Essay",
          "Community"
        ],
        "options": "At Pitzer College, five core values distinguish our approach to education: social responsibility, intercultural understanding, interdisciplinary learning, student engagement, and environmental sustainability. As agents of change, our students utilize these values to create solutions to our world’s challenges: Describe what you are looking for from your college experience and why Pitzer would be a good fit for you.",
        "prompt": "At Pitzer College, five core values distinguish our approach to education: social responsibility, intercultural understanding, interdisciplinary learning, student engagement, and environmental sustainability. As agents of change, our students utilize these values to create solutions to our world’s challenges: Reflecting on your involvement throughout high school or within the community, how have you engaged with one of Pitzer’s core values?",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Diversity",
          "Community"
        ],
        "options": "None",
        "prompt": "As a mission-driven institution, we value and celebrate the synergy created by our differences and similarities. We welcome you to write about distinctive aspects of your background, identity, or personal interests that you would bring to Pitzer, and how you plan to engage in our community.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "pomona_college": {
    "Name": "Pomona College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Questbridge"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Pomona"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "What do you love about the subject(s) you selected as potential major(s)? If undecided, share more about one of your academic passions.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "What item are you excited to bring with you to college?",
          "Describe a time when you felt empowered or on top of the world?"
        ],
        "prompt": "At Pomona, we celebrate and identify with the number 47. Share with us one of your quirky personal, family, or community traditions and why you hold on to it.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "At Pomona, we celebrate and identify with the number 47. Share with us one of your quirky personal, family, or community traditions and why you hold on to it.",
          "Describe a time when you felt empowered or on top of the world?"
        ],
        "prompt": "What item are you excited to bring with you to college?",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "At Pomona, we celebrate and identify with the number 47. Share with us one of your quirky personal, family, or community traditions and why you hold on to it.",
          "What item are you excited to bring with you to college?"
        ],
        "prompt": "Describe a time when you felt empowered or on top of the world?",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "In the past few years, is there something you have changed your mind about? Why?",
          "Reflecting on a community that you are part of, what values or perspectives from that community would you bring to Pomona?"
        ],
        "prompt": "What strength or quality do you have that most people might not see or recognize?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Opinions"
        ],
        "options": [
          "What strength or quality do you have that most people might not see or recognize?",
          "Reflecting on a community that you are part of, what values or perspectives from that community would you bring to Pomona?"
        ],
        "prompt": "In the past few years, is there something you have changed your mind about? Why?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "What strength or quality do you have that most people might not see or recognize?",
          "In the past few years, is there something you have changed your mind about? Why?"
        ],
        "prompt": "Reflecting on a community that you are part of, what values or perspectives from that community would you bring to Pomona?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "princeton_university": {
    "Name": "Princeton University",
    "applications": {
      "appType": [
        "Princeton Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Princeton"
      ]
    },
    "prompts": [
      {
        "category": "Academic Interest",
        "options": "Please describe why you are interested in studying engineering at Princeton. Include any of your experiences in or exposure to engineering, and how you think the programs offered at the University suit your particular interests.",
        "prompt": "As a research institution that also prides itself on its liberal arts curriculum, Princeton allows students to explore areas across the humanities and the arts, the natural sciences, and the social sciences. What academic areas most pique your curiosity, and how do the programs offered at Princeton suit your particular interests?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Academic Interest",
        "options": "As a research institution that also prides itself on its liberal arts curriculum, Princeton allows students to explore areas across the humanities and the arts, the natural sciences, and the social sciences. What academic areas most pique your curiosity, and how do the programs offered at Princeton suit your particular interests?",
        "prompt": "Please describe why you are interested in studying engineering at Princeton. Include any of your experiences in or exposure to engineering, and how you think the programs offered at the University suit your particular interests.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Extended Essay",
          "Experiences"
        ],
        "options": "None",
        "prompt": "Princeton values community and encourages students, faculty, staff and leadership to engage in respectful conversations that can expand their perspectives and challenge their ideas and beliefs. As a prospective member of this community, reflect on how your lived experiences will impact the conversations you will have in the classroom, the dining hall or other campus spaces. What lessons have you learned in life thus far? What will your classmates learn from you? In short, how has your lived experience shaped you?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": "Short answer",
        "options": "None",
        "prompt": "What is a new skill you would like to learn in college?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": "Short answer",
        "options": "None",
        "prompt": "What brings you joy?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": "Short answer",
        "options": "None",
        "prompt": "What song represents the soundtrack of your life at this moment?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Princeton has a longstanding commitment to understanding our responsibility to society through service and civic engagement. How does your own story intersect with these ideals?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "purdue_university": {
    "Name": "Purdue University",
    "applications": {
      "appType": [
        "Purdue Application",
        "Common App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Purdue"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "How will opportunities at Purdue support your interests, both in and out of the classroom?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Academic Interest",
        "options": "None",
        "prompt": "Briefly discuss your reasons for pursuing the major you have selected.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "rensselaer_polytechnic_institute": {
    "Name": "Rensselaer Polytechnic Institute",
    "applications": {
      "appType": [
        "RPI Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "RPI"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "Why are you interested in Rensselaer Polytechnic Institute?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Activity",
        "options": "None",
        "prompt": "Please briefly elaborate on one of your extracurricular activities or work experiences.",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "rice_university": {
    "Name": "Rice University",
    "applications": {
      "appType": [
        "Rice Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Rice"
      ]
    },
    "prompts": [
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "Based upon your exploration of Rice University, what elements of the Rice experience appeal to you?",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Academic Interest",
        "options": "None",
        "prompt": "Please explain why you wish to study in the academic areas you selected.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Community",
        "options": [
          "Rice is strengthened by its diverse community of learning and discovery that produces leaders and change agents across the spectrum of human endeavor. What perspectives shaped by your background, experiences, upbringing, and/or racial identity inspire you to join our community of change agents at Rice?"
        ],
        "prompt": "The Residential College System is at the heart of Rice student life and is heavily influenced by the particular cultural traditions and unique life experiences each student brings. What life experiences and/or unique perspectives are you looking forward to sharing with fellow Owls in the residential college system?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": "Diversity",
        "options": [
          "The Residential College System is at the heart of Rice student life and is heavily influenced by the particular cultural traditions and unique life experiences each student brings. What life experiences and/or unique perspectives are you looking forward to sharing with fellow Owls in the residential college system?"
        ],
        "prompt": "Rice is strengthened by its diverse community of learning and discovery that produces leaders and change agents across the spectrum of human endeavor. What perspectives shaped by your background, experiences, upbringing, and/or racial identity inspire you to join our community of change agents at Rice?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "rutgers_university_new_brunswick": {
    "Name": "Rutgers University - New Brunswick",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Rutgers Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Rutgers"
      ]
    },
    "prompts": []
  },
  "scripps_college": {
    "Name": "Scripps College",
    "applications": {
      "appType": [
        "Common App",
        "Questbridge App",
        "Scripps Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Scripps"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Why have you chosen to apply to Scripps College?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "You’ve invented a time machine! When and where is your first destination and why?",
          "You have just been invited to host your own podcast. What will you talk about and why did you select that topic?"
        ],
        "prompt": "If you could trade lives with someone (fictional or real) for a day, who would it be and why?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "If you could trade lives with someone (fictional or real) for a day, who would it be and why?",
          "You have just been invited to host your own podcast. What will you talk about and why did you select that topic?"
        ],
        "prompt": "You’ve invented a time machine! When and where is your first destination and why?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "If you could trade lives with someone (fictional or real) for a day, who would it be and why?",
          "You’ve invented a time machine! When and where is your first destination and why?"
        ],
        "prompt": "You have just been invited to host your own podcast. What will you talk about and why did you select that topic?",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "southern_methodist_university": {
    "Name": "Southern Methodist University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "SMU Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "SMU"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": "None",
        "prompt": "SMU appeals to students for a variety of reasons. Briefly describe why you are interested in attending SMU and what specific factors have led you to apply.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Community",
          "Experiences"
        ],
        "options": "None",
        "prompt": "SMU is a diverse and welcoming learning environment shaped by the convergence of ideas and cultures. How will your unique experiences enhance the University, and how will you benefit from this community?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "stanford_university": {
    "Name": "Stanford University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition",
        "Questbridge",
        "Stanford Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Stanford"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "The Stanford community is deeply curious and driven to learn in and out of the classroom. Reflect on an idea or experience that makes you genuinely excited about learning.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "The Stanford community is deeply curious and driven to learn in and out of the classroom. Reflect on an idea or experience that makes you genuinely excited about learning.",
          "Please describe what aspects of your life experiences, interests and character would help you make a distinctive contribution as an undergraduate to Stanford University."
        ],
        "prompt": "Virtually all of Stanford’s undergraduates live on campus. Write a note to your future roommate that reveals something about you or that will help your roommate — and us — know you better.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Experiences"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please describe what aspects of your life experiences, interests and character would help you make a distinctive contribution as an undergraduate to Stanford University.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Short Answer",
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "What is the most significant challenge that society faces today?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": [
          "Short Answer",
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "How did you spend your last two summers?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": [
          "Short Answer",
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "What historical moment or event do you wish you could have witnessed?",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": [
          "Short Answer",
          "Activity"
        ],
        "options": [
          "None"
        ],
        "prompt": "Briefly elaborate on one of your extracurricular activities, a job you hold, or responsibilities you have for your family.",
        "status": "Mandatory",
        "wordCount": "50"
      },
      {
        "category": [
          "Short Answer",
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "List five things that are important to you.",
        "status": "Mandatory",
        "wordCount": "50"
      }
    ]
  },
  "swarthmore_college": {
    "Name": "Swarthmore College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Swarthmore Application",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Swarthmore"
      ]
    },
    "prompts": [
      {
        "category": [
          "Opinions",
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "Swarthmore College maintains an ongoing commitment of building a diverse, equitable, and inclusive residential community dedicated to rigorous intellectual inquiry. All who engage in our community are empowered through the open exchange of ideas guided by equity and social responsibility to thrive and contribute as bridge builders within global communities. Our identities and perspectives are supported and developed by our immediate contexts and lived experiences – in our neighborhoods, families, classrooms, communities of faith, and more. What aspects of your self-identity or personal background are most significant to you? Reflecting on the elements of your home, school, or other communities that have shaped your life, explain how you have grown in your ability to navigate differences when engaging with others, or demonstrated your ability to collaborate in communities other than your own.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "What inspires you",
          "Academic interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Swarthmore’s community of learners inspire one another through their collaborative and flexible approach to learning. Swarthmore students are comfortable with intellectual experimentation and connection of ideas across the humanities, social sciences, natural sciences, and interdisciplinary studies through a liberal arts education. Tell us about a topic that has fascinated you recently – either inside or outside of the classroom. What made you curious about this? Has this topic connected across other areas of your interests? How has this experience shaped you and what encourages you to keep exploring?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "syracuse_university": {
    "Name": "Syracuse_University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Syracuse Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Syracuse"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Syracuse University is a place that seeks to be welcoming to all – and has been since our founding. Explain why you are interested in Syracuse University and describe a personal experience in which you persevered through adversity, rejected discrimination, learned a lesson, or were inspired by the courageous actions of others and how you will apply what you learned to our community in a positive way.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "texas_a&m_university": {
    "Name": "Texas A&M University",
    "applications": {
      "appType": [
        "Texas A&M Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Texas A&M"
      ]
    },
    "prompts": [
      {
        "category": "Experiences",
        "options": "None",
        "prompt": "Describe a life event which you feel has prepared you to be successful in college.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Tell us about the person who has most impacted your life and why.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Challenges",
          "Additional Info"
        ],
        "options": "None",
        "prompt": "If there are additional personal challenges, hardships, or opportunities (including COVID related experiences) that have shaped or impacted your abilities or academic credentials, which you have not already written about, please note them in the space below.",
        "status": "Optional",
        "wordCount": "250"
      }
    ]
  },
  "trinity_college": {
    "Name": "Trinity College",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "ApplyTexas App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Trinity College"
      ]
    },
    "prompts": [
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "None"
        ],
        "prompt": "The identities you claim, the challenges you face, and the successes you enjoy shape the background for your college experience to come. What is an aspect of your background that you are excited to share and/or explore as a member of the Trinity community and why?",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "tufts_university": {
    "Name": "Tufts University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Tufts Application",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Tufts"
      ]
    },
    "prompts": [
      {
        "category": [
          "What inspires you"
        ],
        "options": [
          "How have the environments or experiences of your upbringing – your family, home, neighborhood, or community – shaped the person you are today?",
          "Using a specific example or two, tell us about a way that you contributed to building a collaborative and/or inclusive community."
        ],
        "prompt": "It’s cool to love learning. What excites your intellectual curiosity and why?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "It’s cool to love learning. What excites your intellectual curiosity and why?",
          "Using a specific example or two, tell us about a way that you contributed to building a collaborative and/or inclusive community."
        ],
        "prompt": "How have the environments or experiences of your upbringing – your family, home, neighborhood, or community – shaped the person you are today?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "It’s cool to love learning. What excites your intellectual curiosity and why?",
          "How have the environments or experiences of your upbringing – your family, home, neighborhood, or community – shaped the person you are today?"
        ],
        "prompt": "Using a specific example or two, tell us about a way that you contributed to building a collaborative and/or inclusive community.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "Art has the power to disrupt our preconceptions, shape public discourse, and imagine new ways of being in the world. What are the ideas you’d like to explore in your work?",
        "status": "Optional",
        "wordCount": "250"
      },
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "I am applying to Tufts because...",
        "status": "Mandatory",
        "wordCount": "100"
      }
    ]
  },
  "tulane_university": {
    "Name": "Tulane University",
    "applications": {
      "appType": [
        "Common App",
        "Tulane Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Tulane"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Describe why you are interested in joining the Tulane community. Consider your experiences, talents, and values to illustrate what you would contribute to the Tulane community if admitted.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "university_of_california_berkeley": {
    "Name": "University of California - Berkeley",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_davis": {
    "Name": "University of California - Davis",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_irvine": {
    "Name": "University of California - Irvine",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_los_angeles": {
    "Name": "University of California - Los Angeles",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_merced": {
    "Name": "University of California - Merced",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_riverside": {
    "Name": "University of California - Riverside",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_san_francisco": {
    "Name": "University of California - San Francisco",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_san_diego": {
    "Name": "University of California - San Diego",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_santa_barbara": {
    "Name": "University of California - Santa Barbara",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_california_santa_cruz": {
    "Name": "University of California - Santa Cruz",
    "applications": {
      "appType": [
        "UC Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UC"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: What have you done to make your school or your community a better place?",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 1: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 1: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 1: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 1: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 1: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 1: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 1: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 1: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 1: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: What have you done to make your school or your community a better place?",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 2: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 2: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 2: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 2: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 2: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 2: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 2: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 2: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 2: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: What have you done to make your school or your community a better place?",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 3: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 3: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 3: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 3: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 3: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 3: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 3: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 3: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 3: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Challenge"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: What have you done to make your school or your community a better place?",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside of the classroom.",
          "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?"
        ],
        "prompt": "Prompt 4: What have you done to make your school or your community a better place?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "Prompt 4: Describe an example of your leadership experience in which you have positively influenced others, helped resolve disputes or contributed to group efforts over time.",
          "Prompt 4: Every person has a creative side, and it can be expressed in many ways: problem solving, original and innovative thinking, and artistically, to name a few. Describe how you express your creative side.",
          "Prompt 4: What would you say is your greatest talent or skill? How have you developed and demonstrated that talent over time?",
          "Prompt 4: Describe how you have taken advantage of a significant educational opportunity or worked to overcome an educational barrier you have faced.",
          "Prompt 4: Describe the most significant challenge you have faced and the steps you have taken to overcome this challenge. How has this challenge affected your academic achievement?",
          "Prompt 4: Think about an academic subject that inspires you. Describe how you have furthered this interest inside and/or outside",
          "Prompt 4: What have you done to make your school or your community a better place?"
        ],
        "prompt": "Prompt 4: Beyond what has already been shared in your application, what do you believe makes you a strong candidate for admissions to the University of California?",
        "status": "Mandatory",
        "wordCount": "350"
      }
    ]
  },
  "university_of_chicago": {
    "Name": "University of Chicago",
    "applications": {
      "appType": [
        "Common App",
        "UChicago Application",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UChicago"
      ]
    },
    "prompts": [
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Extended Essay",
        "options": [
          "We’re all familiar with green-eyed envy or feeling blue, but what about being \"caught purple-handed\"? Or \"tickled orange\"? Give an old color-infused expression a new hue and tell us what it represents.",
          "\"Ah, but I was so much older then / I’m younger than that now\" – Bob Dylan. In what ways do we become younger as we get older?",
          "Pluto, the demoted planet. Ophiuchus, the thirteenth Zodiac. Andy Murray, the fourth to tennis’s Big Three. Every grouping has something that doesn’t quite fit in. Tell us about a group and its unofficial member, why (or why not) should it be excluded?",
          "\"Daddy-o\", \"Far Out\", \"Gnarly\": the list of slang terms goes on and on. Sadly, most of these aren’t so \"fly\" anymore – \"as if!\" Name an outdated slang from any decade or language that you’d bring back and explain why you totally \"dig it.\"",
          "How many piano tuners are there in Chicago? What is the total length of chalk used by UChicago professors in a year? How many pages of books are in the Regenstein Library? These questions are among a class of estimation problems named after University of Chicago physicist Enrico Fermi. Create your own Fermi estimation problem, give it your best answer, and show us how you got there.",
          "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!"
        ],
        "prompt": "And, as always… the classic choose your own adventure option! In the spirit of adventurous inquiry, choose one of our past prompts (or create a question of your own). Be original, creative, thought-provoking. Draw on your best qualities as a writer, thinker, visionary, social critic, sage, citizen of the world, or future citizen of the University of Chicago; take a little risk, and have fun!",
        "status": "Mandatory",
        "wordCount": "400-700"
      },
      {
        "category": "Why this college?",
        "options": "None",
        "prompt": "How does the University of Chicago, as you know it now, satisfy your desire for a particular kind of learning, community, and future? Please address with some specificity your own wishes and how they relate to UChicago.",
        "status": "Mandatory",
        "wordCount": "300-600"
      }
    ]
  },
  "university_of_florida": {
    "Name": "University of Florida",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UF Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "University of Florida"
      ]
    },
    "prompts": [
      {
        "category": [
          "Activity"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please provide more details on your most meaningful commitment outside of the classroom while in high school and explain why it was meaningful. This could be related to an extracurricular activity, work, volunteering, an academic activity, family responsibility, or any other non-classroom activity.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "As Albert Einstein once said, “The important thing is not to stop questioning. Curiosity has its own reason for existing.” Reflecting on this, what academic subjects, learning opportunities, or extracurricular activities are you most excited to engage in during your college experience? How do you imagine or hope the UF Honors Program will help feed your curiosity and help you achieve your aspirations?",
        "status": "Mandatory",
        "wordCount": "400"
      }
    ]
  },
  "university_of_georgia": {
    "Name": "University of Georgia",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UGA Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UGA"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "The transition from middle to high school is a key time for students as they reach new levels of both academic and personal discovery. Please share a book (novel, non-fiction, etc.) that had a serious impact on you during this time. Please focus more on why this book made an impact on you and less on the plot/theme of the book itself (we are not looking for a book report).",
        "status": "Mandatory",
        "wordCount": "300"
      }
    ]
  },
  "university_of_illinois_urbana_champaign": {
    "Name": "University of Illinois Urbana - Champaign",
    "applications": {
      "appType": [
        "MyIllini Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "MyIllini"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest",
          "Experiences"
        ],
        "options": "If you’re applying to our Undeclared Program in the Division of General Studies: What are your academic interests? Please include 2 - 3 majors you’re considering at Illinois and why.",
        "prompt": "Explain, in detail, an experience you’ve had in the past 3 to 4 years related to your first-choice major. This can be an experience from an extracurricular activity, in a class you’ve taken, or through something else.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": "Explain, in detail, an experience you’ve had in the past 3 to 4 years related to your first-choice major. This can be an experience from an extracurricular activity, in a class you’ve taken, or through something else.",
        "prompt": "If you’re applying to our Undeclared Program in the Division of General Studies: What are your academic interests? Please include 2 - 3 majors you’re considering at Illinois and why.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": "What are your future career or academic goals? You may include courses you took in high school and how these impacted your goals.",
        "prompt": "Describe your personal and/or career goals after graduating from UIUC and how your selected first-choice major will help you achieve them.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Other"
        ],
        "options": "Describe your personal and/or career goals after graduating from UIUC and how your selected first-choice major will help you achieve them.",
        "prompt": "What are your future career or academic goals? You may include courses you took in high school and how these impacted your goals.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": "None",
        "prompt": "You have selected a second-choice major. Please explain your interest in that major or your overall academic or career goals.",
        "status": "Optional",
        "wordCount": "150"
      }
    ]
  },
  "university_of_massachusetts_amherst": {
    "Name": "University of Massachusetts - Amherst",
    "applications": {
      "appType": [
        "Common App",
        "UMass Amherst Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "UMass Amherst"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this College"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please tell us why you want to attend UMass Amherst?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "At UMass Amherst, no two students are alike. Our communities and groups often define us and shape our individual worlds. Community can refer to various aspects, including shared geography, religion, race/ethnicity, income, ideology, and more. Please choose one of your communities or groups and describe its significance. Explain how, as a product of this community or group, you would enrich our campus.",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please tell us why you chose the Majors you did?",
        "status": "Mandatory",
        "wordCount": "100"
      }
    ]
  },
  "university_of_miami": {
    "Name": "University of Miami",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UMiami Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UMiami"
      ]
    },
    "prompts": [
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "None"
        ],
        "prompt": "Located within one of the most dynamic cities in the world, the University of Miami is a distinctive community with a variety of cultures, traditions, histories, languages, and backgrounds. The University of Miami is a values-based and purpose-driven postsecondary institution that embraces diversity and inclusivity in all its forms and strives to create a culture of belonging, where every person feels valued and has an opportunity to contribute. Please describe how your unique experiences, challenges overcome, or skills acquired would contribute to our distinctive University community.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "university_of_michigan": {
    "Name": "University of Michigan",
    "applications": {
      "appType": [
        "UMich Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UMich"
      ]
    },
    "prompts": [
      {
        "category": "Community",
        "options": "None",
        "prompt": "Everyone belongs to many different communities and/or groups defined by (among other things) shared geography, religion, ethnicity, income, cuisine, interest, race, ideology, or intellectual heritage. Choose one of the communities to which you belong, and describe that community and your place within it.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": "Academic Interest",
        "options": "None",
        "prompt": "Describe the unique qualities that attract you to the specific undergraduate College or School (including preferred admission and dual degree programs) to which you are applying at the University of Michigan. How would that curriculum support your interests?",
        "status": "Mandatory",
        "wordCount": "550"
      }
    ]
  },
  "university_of_minnesota_twin_cities": {
    "Name": "University of Minnesota - Twin Cities",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UMinnesota Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UMinnesota"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please include an explanation of why you would like to study the major(s) you have selected. You may also use this space to indicate your interest in other major(s) in the colleges listed above.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "None"
        ],
        "prompt": "The University values diversity, broadly defined to include diversity of experiences, perspectives, backgrounds, and talents. Enrolling a diverse community of scholars interested in learning with and from each other fosters discussion and discovery inside and outside of the classroom. Please share briefly how you might contribute to, or benefit from, our community of scholars.",
        "status": "Mandatory",
        "wordCount": "150"
      }
    ]
  },
  "university_of_north_carolina_at_chapel_hill": {
    "Name": "University of North Carolina - Chapel Hill",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": []
    },
    "prompts": [
      {
        "category": [
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "Discuss one of your personal qualities and share a story, anecdote, or memory of how it helped you make a positive impact on a community. This could be your current community or another community you have engaged.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Discuss an academic topic that you’re excited to explore and learn more about in college. Why does this topic interest you? Topics could be a specific course of study, research interests, or any other area related to your academic experience in college.",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "university_of_notre_dame": {
    "Name": "University of Notre Dame",
    "applications": {
      "appType": [
        "Notre Dame Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Notre Dame"
      ]
    },
    "prompts": [
      {
        "category": "Academic Interest",
        "options": "None",
        "prompt": "Briefly share what draws you to the area(s) of study you listed.",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Everyone has different priorities when considering their higher education options and building their college or university list. Tell us about your “non-negotiable” factor(s) when searching for your future college home.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "How does faith influence the decisions you make?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": [
          "Experiences",
          "Community"
        ],
        "options": "None",
        "prompt": "What is distinctive about your personal experiences and development (eg, family support, culture, disability, personal background, community)?  Why are these experiences important to you and how will you enrich the Notre Dame community?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Community",
        "options": "None",
        "prompt": "Notre Dame’s undergraduate experience is characterized by a collective sense of care for every person.  How do you foster service to others in your community?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "What compliment are you most proud of receiving, and why does it mean so much to you?",
        "status": "Mandatory",
        "wordCount": "100"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "What would you fight for?",
        "status": "Mandatory",
        "wordCount": "100"
      }
    ]
  },
  "university_of_oklahoma": {
    "Name": "University of Oklahoma",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "OU Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "OU"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other",
          "Extended Essay"
        ],
        "options": [
          "None"
        ],
        "prompt": "The University of Oklahoma believes strongly in educating leaders of communities in Oklahoma, as well as across the country and the world. Please share your leadership experiences and why they are important to you.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Extended Essay",
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "The University of Oklahoma is home to a vibrant, diverse and compassionate University community that is often referred to as “the OU family.” Please describe your cultural and community service activities and why you chose to participate in them.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest",
          "Extended Essay"
        ],
        "options": [
          "None"
        ],
        "prompt": "What is your career area of interest, and why do you have a desire to work in this particular field?",
        "status": "Mandatory",
        "wordCount": "650"
      }
    ]
  },
  "university_of_oregon": {
    "Name": "University of Oregon",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UOregon Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UOregon"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "Describe an experience with discrimination, whether it was fighting against discrimination or recognizing your contribution to discriminating against a person or group. What did you learn from the experience? In what ways will you bring those lessons to the University of Oregon?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "university_of_pennsylvania": {
    "Name": "University of Pennsylvania",
    "applications": {
      "appType": [
        "UPenn Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UPenn"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "Write a short thank-you note to someone you have not yet thanked and would like to acknowledge. (We encourage you to share this note with that person, if possible, and reflect on the experience!)",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Community",
          "Experiences"
        ],
        "options": "None",
        "prompt": "How will you explore community at Penn? Consider how Penn will help shape your perspective, and how your experiences and perspective will help shape Penn.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Other",
        "options": [
          "The flexible structure of The College of Arts and Sciences’ curriculum is designed to inspire exploration, foster connections, and help you create a path of study through general education courses and a major. What are you curious about and how would you take advantage of opportunities in the arts and sciences?",
          "Penn Engineering prepares its students to become leaders in technology by combining a strong foundation in the natural sciences and mathematics with depth of study in focused disciplinary majors. Please share how you plan to pursue your engineering interests at Penn.",
          "Penn Nursing intends to meet the health needs of a global, multicultural world by preparing its students to impact healthcare through advancing science. How will you contribute to our mission of promoting equity in healthcare and how will Penn Nursing contribute to your future nursing goals?"
        ],
        "prompt": "Wharton prepares its students to make an impact by applying business methods and economic theory to real-world problems, including economic, political, and social issues. Please reflect on a current issue of importance to you and share how you hope a Wharton education would help you to explore it.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Academic Interest",
        "options": [
          "Wharton prepares its students to make an impact by applying business methods and economic theory to real-world problems, including economic, political, and social issues. Please reflect on a current issue of importance to you and share how you hope a Wharton education would help you to explore it.",
          "Penn Engineering prepares its students to become leaders in technology by combining a strong foundation in the natural sciences and mathematics with depth of study in focused disciplinary majors. Please share how you plan to pursue your engineering interests at Penn.",
          "Penn Nursing intends to meet the health needs of a global, multicultural world by preparing its students to impact healthcare through advancing science. How will you contribute to our mission of promoting equity in healthcare and how will Penn Nursing contribute to your future nursing goals?"
        ],
        "prompt": "The flexible structure of The College of Arts and Sciences’ curriculum is designed to inspire exploration, foster connections, and help you create a path of study through general education courses and a major. What are you curious about and how would you take advantage of opportunities in the arts and sciences?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Other",
        "options": [
          "Wharton prepares its students to make an impact by applying business methods and economic theory to real-world problems, including economic, political, and social issues. Please reflect on a current issue of importance to you and share how you hope a Wharton education would help you to explore it.",
          "The flexible structure of The College of Arts and Sciences’ curriculum is designed to inspire exploration, foster connections, and help you create a path of study through general education courses and a major. What are you curious about and how would you take advantage of opportunities in the arts and sciences?",
          "Penn Engineering prepares its students to become leaders in technology by combining a strong foundation in the natural sciences and mathematics with depth of study in focused disciplinary majors. Please share how you plan to pursue your engineering interests at Penn."
        ],
        "prompt": "Penn Nursing intends to meet the health needs of a global, multicultural world by preparing its students to impact healthcare through advancing science. How will you contribute to our mission of promoting equity in healthcare and how will Penn Nursing contribute to your future nursing goals?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Academic Interest",
        "options": [
          "Wharton prepares its students to make an impact by applying business methods and economic theory to real-world problems, including economic, political, and social issues. Please reflect on a current issue of importance to you and share how you hope a Wharton education would help you to explore it.",
          "The flexible structure of The College of Arts and Sciences’ curriculum is designed to inspire exploration, foster connections, and help you create a path of study through general education courses and a major. What are you curious about and how would you take advantage of opportunities in the arts and sciences?",
          "Penn Nursing intends to meet the health needs of a global, multicultural world by preparing its students to impact healthcare through advancing science. How will you contribute to our mission of promoting equity in healthcare and how will Penn Nursing contribute to your future nursing goals?"
        ],
        "prompt": "Penn Engineering prepares its students to become leaders in technology by combining a strong foundation in the natural sciences and mathematics with depth of study in focused disciplinary majors. Please share how you plan to pursue your engineering interests at Penn.",
        "status": "Mandatory",
        "wordCount": "200"
      }
    ]
  },
  "university_of_pittsburgh": {
    "Name": "University of Pittsburgh",
    "applications": {
      "appType": [
        "Common App",
        "UPittsburgh Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "UPittsburgh"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "None"
        ],
        "prompt": "What is something you would like to see change in the world? Explain why.",
        "status": "Optional",
        "wordCount": "Roughly 300"
      }
    ]
  },
  "university_of_richmond": {
    "Name": "University of Richmond",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "URichmond App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "URichmond App"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Tell us about a time you learned something unexpected. What did you learn, and what happened next?",
          "Richmond welcomes students from various backgrounds, perspectives, and lived experiences. What is at least one way you will contribute to our community that is not already mentioned in your application?"
        ],
        "prompt": "You have a platform to create change. What is an action or policy you might propose to address an issue of social injustice in your school or local community, or on a national or global scale?",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "You have a platform to create change. What is an action or policy you might propose to address an issue of social injustice in your school or local community, or on a national or global scale?",
          "Richmond welcomes students from various backgrounds, perspectives, and lived experiences. What is at least one way you will contribute to our community that is not already mentioned in your application?"
        ],
        "prompt": "Tell us about a time you learned something unexpected. What did you learn, and what happened next?",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "You have a platform to create change. What is an action or policy you might propose to address an issue of social injustice in your school or local community, or on a national or global scale?",
          "Tell us about a time you learned something unexpected. What did you learn, and what happened next?"
        ],
        "prompt": "Richmond welcomes students from various backgrounds, perspectives, and lived experiences. What is at least one way you will contribute to our community that is not already mentioned in your application?",
        "status": "Mandatory",
        "wordCount": "650"
      }
    ]
  },
  "university_of_rochester": {
    "Name": "University of Rochester",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Rochester Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Rochester"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college",
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "The University of Rochester benefactor, entrepreneur, photography pioneer, and philanthropist George Eastman said, \"The progress of the world depends almost entirely upon education.\" In what ways do you envision using the curricular flexibility and co-curricular opportunities at the University of Rochester to promote progress and change within the communities you inhabit?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "university_of_san_diego": {
    "Name": "University of San Diego",
    "applications": {
      "appType": [
        "Common App",
        "USD Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "USD"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "Here at USD, we value the fact that our students come from all walks of life. What contribution have you made to your current school and/or local community that best exemplifies your awareness of and commitment to these ideals?",
          "Write about one of the challenges facing humanity today. Why does it matter to you? What experiences or insights have you had that speak to the urgency of this issue?",
          "Share some of your ideas about the role of faith or spirituality in your life or the life of someone you know."
        ],
        "prompt": "For over 75 years, the liberal arts have been the cornerstone of the educational experience at USD. What excites you about the academic opportunities at USD?",
        "status": "Mandatory",
        "wordCount": "350"
      },
      {
        "category": [
          "Community",
          "Diversity"
        ],
        "options": [
          "For over 75 years, the liberal arts have been the cornerstone of the educational experience at USD. What excites you about the academic opportunities at USD?",
          "Write about one of the challenges facing humanity today. Why does it matter to you? What experiences or insights have you had that speak to the urgency of this issue?",
          "Share some of your ideas about the role of faith or spirituality in your life or the life of someone you know."
        ],
        "prompt": "Here at USD, we value the fact that our students come from all walks of life. What contribution have you made to your current school and/or local community that best exemplifies your awareness of and commitment to these ideals?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "For over 75 years, the liberal arts have been the cornerstone of the educational experience at USD. What excites you about the academic opportunities at USD?",
          "Here at USD, we value the fact that our students come from all walks of life. What contribution have you made to your current school and/or local community that best exemplifies your awareness of and commitment to these ideals?",
          "Share some of your ideas about the role of faith or spirituality in your life or the life of someone you know."
        ],
        "prompt": "Write about one of the challenges facing humanity today. Why does it matter to you? What experiences or insights have you had that speak to the urgency of this issue?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "For over 75 years, the liberal arts have been the cornerstone of the educational experience at USD. What excites you about the academic opportunities at USD?",
          "Here at USD, we value the fact that our students come from all walks of life. What contribution have you made to your current school and/or local community that best exemplifies your awareness of and commitment to these ideals?",
          "Write about one of the challenges facing humanity today. Why does it matter to you? What experiences or insights have you had that speak to the urgency of this issue?"
        ],
        "prompt": "Share some of your ideas about the role of faith or spirituality in your life or the life of someone you know.",
        "status": "Mandatory",
        "wordCount": "200"
      }
    ]
  },
  "university_of_san_francisco": {
    "Name": "University of San Francisco",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "USF Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "University of San Francisco"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community",
          "Diversity"
        ],
        "options": [
          "None"
        ],
        "prompt": "The University of San Francisco’s Jesuit tradition emphasizes community engagement and education for social justice, inspiring our students to become passionate agents for others. How do you see yourself becoming a part of this mission?",
        "status": "Mandatory",
        "wordCount": "200"
      }
    ]
  },
  "university_of_southern_california": {
    "Name": "University of Southern California (USC)",
    "applications": {
      "appType": [
        "Common App",
        "USC Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "USC"
      ]
    },
    "prompts": [
      {
        "category": "Academic Interests",
        "options": "None",
        "prompt": "Describe something outside of your intended academic focus about which you are interested in learning.",
        "status": "Optional",
        "wordCount": 250
      },
      {
        "category": "Academic Interests",
        "options": "None",
        "prompt": "Describe how you plan to pursue your academic interests at USC. Please feel free to address your first- and second-choice major selections.",
        "status": "Mandatory",
        "wordCount": 250
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Describe yourself in three words.",
        "status": "Mandatory",
        "wordCount": 3
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "What is your favorite snack?",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Favorite app/website:",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Best movie of all time:",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Hashtag to describe yourself:",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Dream job:",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "What is your theme song?",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Dream trip:",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "What TV show will you binge watch next?",
        "status": "Mandatory",
        "wordCount": 15
      },
      {
        "category": "Short Answer",
        "options": "None",
        "prompt": "Place you are most content?",
        "status": "Mandatory",
        "wordCount": 15
      }
    ]
  },
  "university_of_texas_austin": {
    "Name": "University of Texas at Austin",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UT App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UT Austin"
      ]
    },
    "prompts": [
      {
        "category": [
          "Additional Info"
        ],
        "options": [],
        "prompt": "Share an essay on any topic of your choice. It can be one you’ve already written, one that responds to a different prompt, or one of your own design. (Note: If applying with the common or coalition app you may reuse your essay)",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Academic Interest"
        ],
        "options": [],
        "prompt": "Why are you interested in the major you indicated as your first-choice major?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Activity"
        ],
        "options": [],
        "prompt": "Think of all the activities — both in and outside of school — that you have been involved with during high school. Which one are you most proud of and why?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Addional Info"
        ],
        "options": [],
        "prompt": "Please share background on events or special circumstances that you feel may have impacted your high school academic performance.",
        "status": "Optional",
        "wordCount": "300"
      }
    ]
  },
  "university_of_tulsa": {
    "Name": "University of Tulsa",
    "applications": {
      "appType": [
        "Common App",
        "UTulsa Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "University of Tulsa"
      ]
    },
    "prompts": [
      {
        "category": [
          "Activity"
        ],
        "options": [
          "None"
        ],
        "prompt": "Please briefly elaborate on one of your extracurricular activities or work experiences.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Why UTulsa? Please explain why you would like to attend The University of Tulsa.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Activity"
        ],
        "options": [
          "None"
        ],
        "prompt": "How do you spend your time outside of school?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "None"
        ],
        "prompt": "How do you see yourself contributing to TU?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [
          "None"
        ],
        "prompt": "Is there any additional information you would like the admission committee to consider?",
        "status": "Mandatory",
        "wordCount": "200"
      }
    ]
  },
  "university_of_vermont": {
    "Name": "University of Vermont",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UVM Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UVM"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": [
          "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
          "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
          "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
          "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?",
          "What is your favorite sentence from your application essay?"
        ],
        "prompt": "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
          "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
          "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
          "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?",
          "What is your favorite sentence from your application essay?"
        ],
        "prompt": "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [
          "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
          "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
          "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
          "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?",
          "What is your favorite sentence from your application essay?"
        ],
        "prompt": "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Location"
        ],
        "options": [
          "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
          "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
          "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
          "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?",
          "What is your favorite sentence from your application essay?"
        ],
        "prompt": "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
          "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
          "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
          "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
          "What is your favorite sentence from your application essay?"
        ],
        "prompt": "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?",
        "status": "Mandatory",
        "wordCount": "500"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "Why UVM? When all else fails, there’s always the classic Why essay. Why are you interested in attending UVM?",
          "Established in Burlington, VT, Ben & Jerry’s is synonymous with both ice cream and social change. If you worked alongside Ben & Jerry, what charitable flavor would you develop and why?",
          "UVM is a community that celebrates the unique identity of every student, faculty, and staff member. Tell us how your identities have shaped the ways you interact with the world.",
          "From the Green Mountains to Lake Champlain, UVM students are inspired by our location to think about their relationship to the environment. What does your relationship with your environment look like?",
          "If you could pick one song to be the soundtrack of your life, what would it be? What is your connection to the song?"
        ],
        "prompt": "What is your favorite sentence from your application essay?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "university_of_virginia": {
    "Name": "University of Virginia",
    "applications": {
      "appType": [
        "UVA Application",
        "Common App",
        "QuestBridge App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "UVA"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "In the field of nursing, you will encounter and impact real human lives. Please explain why you feel this is important as you choose this field as your future.",
        "status": "Optional",
        "wordCount": "Roughly 250"
      },
      {
        "category": "Experiences",
        "options": "None",
        "prompt": "What about your individual background, perspective, or experience will serve as a source of strength for you or those around you at UVA?  Feel free to write about any past experience or part of your background that has shaped your perspective and will be a source of strength, including but not limited to those related to your community, upbringing, educational environment, race, gender, or other aspects of your background that are important to you.",
        "status": "Mandatory",
        "wordCount": "Roughly 250"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "If you have a personal or historic connection with UVA, and if you’d like to share how your experience of this connection has prepared you to contribute to the University, please share your thoughts here.  Such relationships might include, but are not limited to, being a child of someone who graduated from or works for UVA, a descendant of ancestors who labored at UVA, or a participant in UVA programs.",
        "status": "Optional",
        "wordCount": "Roughly 250"
      }
    ]
  },
  "university_of_washington": {
    "Name": "University of Washington",
    "applications": {
      "appType": [
        "UWashington Application"
      ],
      "coalitionApp": false,
      "commonApp": false,
      "specificApps": [
        "UWashington"
      ]
    },
    "prompts": [
      {
        "category": [
          "Extended Essay"
        ],
        "options": [],
        "prompt": "Tell a story from your life, describing an experience that either demonstrates your character or helped to shape it.",
        "status": "Mandatory",
        "wordCount": "650"
      },
      {
        "category": [
          "Diversity"
        ],
        "options": [],
        "prompt": "Our families and communities often define us and our individual worlds. Community might refer to your cultural group, extended family, religious group, neighborhood or school, sports team or club, co-workers, etc. Describe the world you come from and how you, as a product of it, might add to the diversity of the University of Washington.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [],
        "prompt": "Additional Information About Yourself or Your Circumstances: You are not required to write anything in this section, but feel free to include additional information if something has particular significance to you.",
        "status": "Optional",
        "wordCount": "200"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": [],
        "prompt": "Additional Space (Optional): You may use this space if you need to further explain or clarify answers you have given elsewhere in this application.",
        "status": "Optional",
        "wordCount": "200"
      }
    ]
  },
  "university_of_wisconsin_madison": {
    "Name": "University of Wisconsin - Madison",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "UWisco Madison Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "UWisco - Madison"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college",
          "Academic Interest"
        ],
        "options": [
          "None"
        ],
        "prompt": "Tell us why you would like to apply to the University of Wisconsin-Madison. In addition, please include why you are interested in studying the major(s) you have selected. If you selected undecided please describe your areas of possible academic interest.",
        "status": "Mandatory",
        "wordCount": "650"
      }
    ]
  },
  "vanderbilt_university": {
    "Name": "Vanderbilt University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Vanderbilt Application",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Vanderbilt"
      ]
    },
    "prompts": [
      {
        "category": [
          "Community",
          "Experiences"
        ],
        "options": [
          "None"
        ],
        "prompt": "Vanderbilt University’s motto, Crescere aude, is Latin for “dare to grow.” In your response, reflect on how one or more aspects of your identity, culture, or background has played a role in your personal growth, and how it will contribute to our campus community as you dare to grow at Vanderbilt.",
        "status": "Mandatory",
        "wordCount": "Roughly 250"
      }
    ]
  },
  "vassar_college": {
    "Name": "Vassar College",
    "applications": {
      "appType": [
        "Vassar Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Vassar"
      ]
    },
    "prompts": [
      {
        "category": [
          "Experiences",
          "Diversity"
        ],
        "options": "Vassar is a diverse community that inspires positive change through open inquiry, deep dives into society’s most difficult challenges, and collaborative problem solving. We care deeply about one another, the communities that have forged us, and the community we build together on campus. Tell us about the community (or communities) you come from and how it has shaped your lived experiences and identity.",
        "prompt": "At Vassar, we aim to foster an inclusive community through our philosophy of engaged pluralism. Engaged pluralism is rooted in “the conviction that collaborating across differences is necessary for social transformation and critical for the well-being of any community and its members.” In short, we believe it’s our differences that make us stronger. Tell us a little bit about an important part of your identity and how it has shaped your life and/or interactions with others.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Experiences",
          "Community"
        ],
        "options": "At Vassar, we aim to foster an inclusive community through our philosophy of engaged pluralism. Engaged pluralism is rooted in “the conviction that collaborating across differences is necessary for social transformation and critical for the well-being of any community and its members.” In short, we believe it’s our differences that make us stronger. Tell us a little bit about an important part of your identity and how it has shaped your life and/or interactions with others.",
        "prompt": "Vassar is a diverse community that inspires positive change through open inquiry, deep dives into society’s most difficult challenges, and collaborative problem solving. We care deeply about one another, the communities that have forged us, and the community we build together on campus. Tell us about the community (or communities) you come from and how it has shaped your lived experiences and identity.",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Other"
        ],
        "options": "None",
        "prompt": "Your Space is your opportunity to allow the Committee on Admission to learn something about you that you have not addressed in another section of the application. For example, in the past, applicants have shared poetry, short stories, cartoons, digital images of art projects, photography, and collages, and/or links to videos, and short films. It is your space, so if you choose to complete it, send something that is a reflection of you! ",
        "status": "Optional",
        "wordCount": "N/A"
      },
      {
        "category": [
          "Additional Info"
        ],
        "options": "None",
        "prompt": "If you wish to provide details of circumstances not reflected in the application, please upload a file here. Similarly, if you wish to upload your resume, include it here.",
        "status": "Optional",
        "wordCount": "N/A"
      }
    ]
  },
  "villanova_university": {
    "Name": "Villanova University",
    "applications": {
      "appType": [
        "Common App",
        "Villanova Application"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Villanova"
      ]
    },
    "prompts": [
      {
        "category": [
          "Other"
        ],
        "options": [
          "Villanova’s Augustinian tradition calls us to be compassionate truth-seekers, to be changemakers and people who contribute to the common good. Tell us about a time when you worked with others to create a positive impact in your community. What did you learn from this experience?",
          "St. Augustine stated that the path to self-knowledge and wisdom is often a long and winding journey. Reflecting on your own life experiences, what does it mean to discover one’s own identity? How have you pursued or explored your personal sense of identity?",
          "At Villanova, we believe that each of us is called to ignite change and contribute to the greater good of society. Describe a time you were faced with a problem that you could have walked away from but chose instead to confront. What motivated you to take action?",
          "In the Villanova community, we believe that it’s our obligation to ignite change and contribute to the greater good. What cause are you passionate about, and how have you been involved? How has it impacted you?"
        ],
        "prompt": "What is the truest sense of you? What makes you feel alive and inspired? Explain how you can relate or connect this to an idea, movement, work of art, or personal experience that resonates with your vision for the future.",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Community"
        ],
        "options": [
          "What is the truest sense of you? What makes you feel alive and inspired? Explain how you can relate or connect this to an idea, movement, work of art, or personal experience that resonates with your vision for the future.",
          "St. Augustine stated that the path to self-knowledge and wisdom is often a long and winding journey. Reflecting on your own life experiences, what does it mean to discover one’s own identity? How have you pursued or explored your personal sense of identity?",
          "At Villanova, we believe that each of us is called to ignite change and contribute to the greater good of society. Describe a time you were faced with a problem that you could have walked away from but chose instead to confront. What motivated you to take action?",
          "In the Villanova community, we believe that it’s our obligation to ignite change and contribute to the greater good. What cause are you passionate about, and how have you been involved? How has it impacted you?"
        ],
        "prompt": "Villanova’s Augustinian tradition calls us to be compassionate truth-seekers, to be changemakers and people who contribute to the common good. Tell us about a time when you worked with others to create a positive impact in your community. What did you learn from this experience?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Experiences"
        ],
        "options": [
          "What is the truest sense of you? What makes you feel alive and inspired? Explain how you can relate or connect this to an idea, movement, work of art, or personal experience that resonates with your vision for the future.",
          "Villanova’s Augustinian tradition calls us to be compassionate truth-seekers, to be changemakers and people who contribute to the common good. Tell us about a time when you worked with others to create a positive impact in your community. What did you learn from this experience?",
          "At Villanova, we believe that each of us is called to ignite change and contribute to the greater good of society. Describe a time you were faced with a problem that you could have walked away from but chose instead to confront. What motivated you to take action?",
          "In the Villanova community, we believe that it’s our obligation to ignite change and contribute to the greater good. What cause are you passionate about, and how have you been involved? How has it impacted you?"
        ],
        "prompt": "St. Augustine stated that the path to self-knowledge and wisdom is often a long and winding journey. Reflecting on your own life experiences, what does it mean to discover one’s own identity? How have you pursued or explored your personal sense of identity?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "What is the truest sense of you? What makes you feel alive and inspired? Explain how you can relate or connect this to an idea, movement, work of art, or personal experience that resonates with your vision for the future.",
          "Villanova’s Augustinian tradition calls us to be compassionate truth-seekers, to be changemakers and people who contribute to the common good. Tell us about a time when you worked with others to create a positive impact in your community. What did you learn from this experience?",
          "St. Augustine stated that the path to self-knowledge and wisdom is often a long and winding journey. Reflecting on your own life experiences, what does it mean to discover one’s own identity? How have you pursued or explored your personal sense of identity?",
          "In the Villanova community, we believe that it’s our obligation to ignite change and contribute to the greater good. What cause are you passionate about, and how have you been involved? How has it impacted you?"
        ],
        "prompt": "At Villanova, we believe that each of us is called to ignite change and contribute to the greater good of society. Describe a time you were faced with a problem that you could have walked away from but chose instead to confront. What motivated you to take action?",
        "status": "Mandatory",
        "wordCount": "250"
      },
      {
        "category": [
          "Other"
        ],
        "options": [
          "What is the truest sense of you? What makes you feel alive and inspired? Explain how you can relate or connect this to an idea, movement, work of art, or personal experience that resonates with your vision for the future.",
          "Villanova’s Augustinian tradition calls us to be compassionate truth-seekers, to be changemakers and people who contribute to the common good. Tell us about a time when you worked with others to create a positive impact in your community. What did you learn from this experience?",
          "St. Augustine stated that the path to self-knowledge and wisdom is often a long and winding journey. Reflecting on your own life experiences, what does it mean to discover one’s own identity? How have you pursued or explored your personal sense of identity?",
          "At Villanova, we believe that each of us is called to ignite change and contribute to the greater good of society. Describe a time you were faced with a problem that you could have walked away from but chose instead to confront. What motivated you to take action?"
        ],
        "prompt": "In the Villanova community, we believe that it’s our obligation to ignite change and contribute to the greater good. What cause are you passionate about, and how have you been involved? How has it impacted you?",
        "status": "Mandatory",
        "wordCount": "250"
      }
    ]
  },
  "virginia_tech": {
    "Name": "Virginia Institute of Technology (Virginia Tech)",
    "applications": {
      "appType": [
        "Virginia Tech Application",
        "Common App"
      ],
      "coalitionApp": false,
      "commonApp": true,
      "specificApps": [
        "Virginia Tech"
      ]
    },
    "prompts": [
      {
        "category": "Community",
        "options": "None",
        "prompt": "Virginia Tech’s motto is “Ut Prosim” which means ‘That I May Serve’. Share how you contribute to a community that is important to you. How long have you been involved? What have you learned and how would you like to share that with others at Virginia Tech?",
        "status": "Mandatory",
        "wordCount": "120"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Virginia Tech’s Principles of Community supports access and inclusion by affirming the dignity and value of every person, respecting differences, promoting mutual understanding and open expression, and strives to eliminate bias and discrimination. Reflect on a time when you were not able or allowed to express a different or diverse position or opinion (or you witnessed another person or group experience the same situation)? How did you respond or wish you would have responded? Did your viewpoint change in any way after this experience?",
        "status": "Mandatory",
        "wordCount": "120"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Share a time when you were most proud of yourself either as a role model or when you displayed your leadership. What specific skills did you contribute to the experience? How did others rely on you for guidance? What did you learn about yourself during this time?",
        "status": "Mandatory",
        "wordCount": "120"
      },
      {
        "category": "Other",
        "options": "None",
        "prompt": "Describe a goal that you have set and the steps you will take to achieve it. What made you set this goal for yourself? What is your timeline to achieve this goal? Who do you seek encouragement or guidance from as you work on this goal?",
        "status": "Mandatory",
        "wordCount": "120"
      }
    ]
  },
  "wake_forest_university": {
    "Name": "WakeForest University",
    "applications": {
      "appType": [
        "Wakeforest Application",
        "Common App",
        "Coalition App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Wakeforest"
      ]
    },
    "prompts": [
      {
        "category": [
          "Why this college"
        ],
        "options": "None",
        "prompt": "Why have you decided to apply to Wake Forest? Share with us anything that has made you interested in our institution.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": "None",
        "prompt": "List five books you have read that intrigued you.",
        "status": "Mandatory",
        "wordCount": "5 Lines"
      },
      {
        "category": [
          "What inspires you",
          "Activity"
        ],
        "options": "None",
        "prompt": "Tell us what piques your intellectual curiosity or has helped you understand the world’s complexity. This can include a work you’ve read, a project you’ve completed for a class, and even co-curricular activities in which you have been involved.",
        "status": "Mandatory",
        "wordCount": "150"
      },
      {
        "category": [
          "Community"
        ],
        "options": "None",
        "prompt": "Dr. Maya Angelou, renowned author, poet, civil-rights activist, and former Wake Forest University Reynolds Professor of American Studies, inspired others to celebrate their identities and to honor each person’s dignity. Choose one of Dr. Angelou’s powerful quotes. How does this quote relate to your lived experience or reflect how you plan to contribute to the Wake Forest community?",
        "status": "Mandatory",
        "wordCount": "300"
      },
      {
        "category": [
          "Short Answer"
        ],
        "options": "None",
        "prompt": "Give us your top ten list.",
        "status": "Mandatory",
        "wordCount": "10 Items"
      }
    ]
  },
  "washington_university_in_st_louis": {
    "Name": "Washington University in St. Louis",
    "applications": {
      "appType": [
        "WashU Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "WashU"
      ]
    },
    "prompts": [
      {
        "category": [
          "Academic Interest",
          "Why this college"
        ],
        "options": "None",
        "prompt": "Please tell us what you are interested in studying at college and why. Undecided about your academic interest(s)? Don’t worry—tell us what excites you about the academic division you selected. Remember that all of our first-year students enter officially 'undeclared' and work closely with their team of academic advisors to discover their academic passions. You can explore all of our majors and programs on our website.",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": [
          "Community"
        ],
        "options": "None",
        "prompt": "WashU is a place that values diversity of perspectives. We believe those perspectives come from a variety of experiences and identities. Respond to one of the following prompts to help us understand 'Who are you?': WashU strives to know every undergraduate student 'by Name & Story.' How have your life experiences shaped your story?",
        "status": "Optional",
        "wordCount": "250"
      },
      {
        "category": [
          "Experiences"
        ],
        "options": "None",
        "prompt": "WashU is a place that values diversity of perspectives. We believe those perspectives come from a variety of experiences and identities. Respond to one of the following prompts to help us understand 'Who are you?': WashU supports engagement in the St. Louis community by considering the university as 'in St. Louis, For St. Louis.' What is a community you are a part of and your place or impact within it?",
        "status": "Optional",
        "wordCount": "250"
      }
    ]
  },
  "wesleyan_university": {
    "Name": "Wesleyan University",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        ""
      ]
    },
    "prompts": []
  },
  "worcester_polytechnic_institute": {
    "Name": "Worcester_Polytechnic_Institute",
    "applications": {
      "appType": [
        "Common App",
        "Coalition App",
        "Worcester Polytechnic Application"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Worcester Polytechnic"
      ]
    },
    "prompts": [
      {
        "category": [
          "Extended Essay",
          "Why this college"
        ],
        "options": [
          "None"
        ],
        "prompt": "Worcester Polytechnic Institute seeks students who are the right fit for its academic and campus community. In what ways are you the right fit for the distinctive educational and campus experience that Worcester Polytechnic Institute offers?",
        "status": "Mandatory",
        "wordCount": "500"
      }
    ]
  },
  "yale_university": {
    "Name": "Yale University",
    "applications": {
      "appType": [
        "Yale Application",
        "Common App",
        "Coalition App",
        "QuestBridge App"
      ],
      "coalitionApp": true,
      "commonApp": true,
      "specificApps": [
        "Yale"
      ]
    },
    "prompts": [
      {
        "category": "Other",
        "options": "None",
        "prompt": "Tell us about a topic or idea that excites you and is related to one or more academic areas you selected above. Why are you drawn to it?",
        "status": "Mandatory",
        "wordCount": "200"
      },
      {
        "category": "Why this college",
        "options": "None",
        "prompt": "What is it about Yale that has led you to apply?",
        "status": "Mandatory",
        "wordCount": "125"
      },
      {
        "category": [
          "Short answer",
          "What inspires you"
        ],
        "options": "None",
        "prompt": "What inspires you?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": "Short answer",
        "options": "None",
        "prompt": "If you could teach any college course, write a book, or create an original piece of art of any kind, what would it be?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": "Short answer",
        "options": "None",
        "prompt": "Other than a family member, who is someone who has had a significant influence on you? What has been the impact of their influence?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": [
          "Short answer",
          "Additional Info"
        ],
        "options": "None",
        "prompt": "What is something about you that is not included anywhere else in your application?",
        "status": "Mandatory",
        "wordCount": "200 characters"
      },
      {
        "category": "Opinions",
        "options": [
          "Reflect on your membership in a community to which you feel connected. Why is this community meaningful to you? You may define community however you like.",
          "Reflect on an element of your personal experience that you feel will enrich your college. How has it shaped you?"
        ],
        "prompt": "Reflect on a time you discussed an issue important to you with someone holding an opposing view. Why did you find the experience meaningful?",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": "Experiences",
        "options": [
          "Reflect on your membership in a community to which you feel connected. Why is this community meaningful to you? You may define community however you like.",
          "Reflect on a time you discussed an issue important to you with someone holding an opposing view. Why did you find the experience meaningful?"
        ],
        "prompt": "Reflect on an element of your personal experience that you feel will enrich your college. How has it shaped you?",
        "status": "Mandatory",
        "wordCount": "400"
      },
      {
        "category": "Commmunity",
        "options": [
          "Reflect on a time you discussed an issue important to you with someone holding an opposing view. Why did you find the experience meaningful?",
          "Reflect on an element of your personal experience that you feel will enrich your college. How has it shaped you?"
        ],
        "prompt": "Reflect on your membership in a community to which you feel connected. Why is this community meaningful to you? You may define community however you like.",
        "status": "Mandatory",
        "wordCount": "400"
      }
    ]
  }
}